"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[12683],{

/***/ 52827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61876);
/* harmony import */ var lib_api_stream__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51679);
/* harmony import */ var lib_api_friends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63699);
/* harmony import */ var utils_stream__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14601);
/* eslint-disable no-undef */ 



// APIs



// Initial state
var initialState = {
    pinnedPost: {
        data: {},
        isLoading: false,
        message: "",
        error: null
    },
    followedBy: {
        data: {},
        isLoading: false
    }
};
// selectors
var userProfile = function(state) {
    return state.userProfile;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(userProfile, function(profile) {
    return {
        pinnedPost: profile.pinnedPost,
        followedBy: profile.followedBy
    };
});
// Action types
var CONTEXT = "@features/user-profile";
var actionType = {
    GET_PINNED_POST: "".concat(CONTEXT, "/GET_PINNED_POST"),
    GET_FOLLOWED_BY: "".concat(CONTEXT, "/GET_FOLLOWED_BY")
};
// side effects
var effects = {
    getPinnedPost: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.GET_PINNED_POST, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var username, response, _data, _$error, postData, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        username = param.username;
                        _ctx.prev = 1;
                        if (username) {
                            _ctx.next = 4;
                            break;
                        }
                        throw new Error("Username is required!");
                    case 4:
                        _ctx.next = 6;
                        return lib_api_stream__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getPinnedPost */ .Z.getPinnedPost(username);
                    case 6:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error("Attempt to get user pinned post failed");
                    case 9:
                        _data = response.data, _$error = _data.error_type, postData = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 12;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 12:
                        data = (0,utils_stream__WEBPACK_IMPORTED_MODULE_3__/* .transformStreamV3 */ .hp)(postData);
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            username: username
                        });
                    case 16:
                        _ctx.prev = 16;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0,
                            username: username
                        });
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    16
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getFollowedBy: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.GET_FOLLOWED_BY, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
            var _page, page, _keyword, keyword, _limit, limit, userId, username, response, _data, _$error, data, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _page = params.page, page = _page === void 0 ? 1 : _page, _keyword = params.keyword, keyword = _keyword === void 0 ? null : _keyword, _limit = params.limit, limit = _limit === void 0 ? 10 : _limit, userId = params.userId, username = params.username;
                        _ctx.next = 4;
                        return lib_api_friends__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getFollowedBy */ .Z.getFollowedBy({
                            page: page,
                            keyword: keyword,
                            limit: limit,
                            userid: userId
                        });
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get followed by failed");
                    case 7:
                        _data = response.data, _$error = _data.error_type, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            username: username
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }));
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducers
var reducers = {};
var extraReducers = function(builder) {
    builder.addCase(effects.getPinnedPost.pending, function(state) {
        state.pinnedPost.isLoading = true;
        state.pinnedPost.error = null;
    }).addCase(effects.getPinnedPost.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data, username = _payload.username;
        if (error) {
            state.pinnedPost.data[username] = undefined;
            state.pinnedPost.error = error;
        } else {
            state.pinnedPost.data[username] = data;
            state.pinnedPost.error = null;
        }
        state.pinnedPost.message = message;
        state.pinnedPost.isLoading = false;
    }).addCase(effects.getPinnedPost.rejected, function(state, action) {
        var _payload = action.payload, error = _payload.error, username = _payload.username;
        state.pinnedPost.isLoading = false;
        state.pinnedPost.data[username] = undefined;
        state.pinnedPost.error = error;
    })// Followed By
    .addCase(effects.getFollowedBy.pending, function(state) {
        state.followedBy.isLoading = true;
    }).addCase(effects.getFollowedBy.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, username = _payload.username;
        var _arg = action.meta.arg, _page = _arg.page, page = _page === void 0 ? 1 : _page;
        if (data) {
            if (page === 1) {
                state.followedBy.data[username] = data;
            } else if (page > 1) {
                state.followedBy.data[username] = {
                    total_follower: data.total_follower,
                    user: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(state.followedBy.data[username].user).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(data.user))
                };
            }
        }
        state.followedBy.isLoading = false;
    });
};
var userProfileSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSlice */ .oM)({
    name: "userProfile",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (userProfileSlice);


/***/ }),

/***/ 98170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61876);
/* harmony import */ var lib_api_watchlist__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15056);
/* harmony import */ var lib_api_friends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63699);




// APIs


// Initial State
var initialState = {
    followers: {
        company: {},
        user: {},
        isLoading: false,
        error: null,
        message: "",
        pagination: {
            more: true,
            page: 1,
            search: undefined
        }
    },
    following: {
        user: {},
        isLoading: false,
        error: null,
        message: "",
        pagination: {
            more: true,
            page: 1,
            search: undefined
        }
    },
    mutualFollower: {
        user: {},
        isLoading: false,
        error: null,
        message: "",
        pagination: {
            more: true,
            page: 1,
            search: undefined
        }
    }
};
// Selectors
var moderationState = function(state) {
    return state.moderation;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSelector */ .P1)(moderationState, function(moderation) {
    return {
        followers: moderation.followers,
        userFollowers: moderation.followers.user,
        companyFollowers: moderation.followers.company,
        isLoadingFollower: moderation.followers.isLoading,
        followersPagination: moderation.followers.pagination,
        following: moderation.following,
        userFollowing: moderation.following.user,
        isLoadingFollowing: moderation.following.isLoading,
        followingPagination: moderation.following.pagination,
        mutualFollower: moderation.mutualFollower,
        userMutualFollower: moderation.mutualFollower.user,
        isLoadingMutualFollower: moderation.mutualFollower.isLoading,
        mutualFollowerPagination: moderation.mutualFollower.pagination
    };
});
// Action types
var CONTEXT = "@redux/moderation";
var actionType = {
    GET_FOLLOWER: "".concat(CONTEXT, "/GET_FOLLOWER"),
    GET_FOLLOWING: "".concat(CONTEXT, "/GET_FOLLOWING"),
    GET_MUTUAL_FOLLOWER: "".concat(CONTEXT, "/GET_MUTUAL_FOLLOWER"),
    TOGGLE_FOLLOW_USER: "".concat(CONTEXT, "/TOGGLE_FOLLOW_USER")
};
// Side effects
var effects = {
    getFollowers: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)(actionType.GET_FOLLOWER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var _page, page, keyword, symbol, username, response, _data, _$error, data, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _page = param.page, page = _page === void 0 ? 1 : _page, keyword = param.keyword, symbol = param.companyid, username = param.userid;
                        _ctx.prev = 1;
                        ;
                        if (!symbol) {
                            _ctx.next = 9;
                            break;
                        }
                        _ctx.next = 6;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getCompanyFollowers */ .Z.getCompanyFollowers(symbol, {
                            page: page,
                            keyword: keyword
                        });
                    case 6:
                        response = _ctx.sent;
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.next = 11;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getPeopleFollowers */ .Z.getPeopleFollowers(username, {
                            page: page,
                            keyword: keyword
                        });
                    case 11:
                        response = _ctx.sent;
                    case 12:
                        if (response.data) {
                            _ctx.next = 14;
                            break;
                        }
                        throw new Error("Attempt to get followers failed");
                    case 14:
                        _data = response.data, _$error = _data.error_type, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 17;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 17:
                        return _ctx.abrupt("return", {
                            data: data.users,
                            more: data.more,
                            message: message,
                            username: username,
                            symbol: symbol
                        });
                    case 20:
                        _ctx.prev = 20;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 23:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    20
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getUserFollowing: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)(actionType.GET_FOLLOWING, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var _page, page, keyword, userid, response, _data, _$error, data, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _page = param.page, page = _page === void 0 ? 1 : _page, keyword = param.keyword, userid = param.userid;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getPeopleFollowing */ .Z.getPeopleFollowing(userid, {
                            page: page,
                            keyword: keyword
                        });
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get user following failed");
                    case 7:
                        _data = response.data, _$error = _data.error_type, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data.users,
                            more: data.more,
                            message: message,
                            userid: userid
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getMutualFollower: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)(actionType.GET_MUTUAL_FOLLOWER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var _page, page, keyword, userid, _limit, limit, response, _data, _$error, data, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _page = param.page, page = _page === void 0 ? 1 : _page, keyword = param.keyword, userid = param.userid, _limit = param.limit, limit = _limit === void 0 ? 10 : _limit;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_friends__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getFollowedBy */ .Z.getFollowedBy({
                            page: page,
                            keyword: keyword,
                            limit: limit,
                            userid: userid
                        });
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get followed by failed");
                    case 7:
                        _data = response.data, _$error = _data.error_type, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            userid: userid
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    followUser: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)(actionType.TOGGLE_FOLLOW_USER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var userid, _type, type, targetAPI, response, _data, _$error, data, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        userid = param.userid, _type = param.type, type = _type === void 0 ? "FOLLOW" : _type;
                        _ctx.prev = 1;
                        if (userid) {
                            _ctx.next = 4;
                            break;
                        }
                        throw new Error("User ID is required");
                    case 4:
                        targetAPI = lib_api_watchlist__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postFollowUser */ .Z.postFollowUser;
                        if (type === "UNFOLLOW") {
                            targetAPI = lib_api_watchlist__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postUnfollowUser */ .Z.postUnfollowUser;
                        }
                        _ctx.next = 8;
                        return targetAPI(userid);
                    case 8:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 11;
                            break;
                        }
                        throw new Error("Attempt to follow user failed");
                    case 11:
                        _data = response.data, _$error = _data.error_type, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 14;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 14:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 17:
                        _ctx.prev = 17;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    17
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducers
var reducers = {
    resetFollowersState: function(draft) {
        draft.followers.pagination.more = true;
        draft.followers.pagination.page = 1;
        draft.followers.pagination.search = undefined;
        draft.followers.company = {};
        draft.followers.user = {};
    },
    resetFollowingState: function(draft) {
        draft.following.pagination.more = true;
        draft.following.pagination.page = 1;
        draft.following.pagination.search = undefined;
        draft.following.user = {};
    },
    resetMutualFollowerState: function(draft) {
        draft.mutualFollower.pagination.more = true;
        draft.mutualFollower.pagination.page = 1;
        draft.mutualFollower.pagination.search = undefined;
    // draft.mutualFollower.user = {};
    },
    searchFollowers: function(draft, action) {
        draft.followers.pagination.more = true;
        draft.followers.pagination.page = 1;
        draft.followers.pagination.search = action.payload;
    },
    searchFollowing: function(draft, action) {
        draft.following.pagination.more = true;
        draft.following.pagination.page = 1;
        draft.following.pagination.search = action.payload;
    },
    searchMutualFollower: function(draft, action) {
        draft.mutualFollower.pagination.more = true;
        draft.mutualFollower.pagination.page = 1;
        draft.mutualFollower.pagination.search = action.payload;
    }
};
var extraReducers = function(builder) {
    builder.addCase(effects.getFollowers.pending, function(state, action) {
        state.followers.isLoading = true;
        state.followers.error = null;
        var _arg = action.meta.arg, page = _arg.page, username = _arg.userid, symbol = _arg.companyid;
        if (page === 1) {
            if (symbol) {
                state.followers.company[symbol] = [];
            } else if (username) {
                state.followers.user[username] = [];
            }
        }
    }).addCase(effects.getFollowers.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message, username = _payload.username, symbol = _payload.symbol, more = _payload.more;
        if (error) {
            state.followers.error = error;
        } else {
            var followersData = data || [];
            if (username) {
                var _ref;
                var ref;
                (ref = state.followers.user[username]) === null || ref === void 0 ? void 0 : (_ref = ref).push.apply(_ref, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(followersData));
            } else if (symbol) {
                var _ref1;
                var ref1;
                (ref1 = state.followers.company[symbol]) === null || ref1 === void 0 ? void 0 : (_ref1 = ref1).push.apply(_ref1, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(followersData));
            }
        }
        state.followers.isLoading = false;
        state.followers.message = message;
        state.followers.pagination.more = more;
        state.followers.pagination.page = action.meta.arg.page + 1;
    }).addCase(effects.getFollowers.rejected, function(state, action) {
        state.followers.isLoading = false;
        state.followers.error = action.payload.error;
        state.followers.pagination.more = false;
        state.followers.pagination.page = 1;
    }).addCase(effects.getUserFollowing.pending, function(state, action) {
        state.following.isLoading = true;
        state.following.error = null;
        var _arg = action.meta.arg, page = _arg.page, userid = _arg.userid;
        if (page === 1) {
            state.following.user[userid] = [];
        }
    }).addCase(effects.getUserFollowing.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message, userid = _payload.userid, more = _payload.more;
        if (error) {
            state.following.error = error;
        } else {
            var _userid;
            var followingData = data || [];
            (_userid = state.following.user[userid]).push.apply(_userid, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(followingData));
        }
        state.following.isLoading = false;
        state.following.message = message;
        state.following.pagination.more = more;
        state.following.pagination.page = action.meta.arg.page + 1;
    }).addCase(effects.getUserFollowing.rejected, function(state, action) {
        state.following.isLoading = false;
        state.following.error = action.payload.error;
        state.following.pagination.more = false;
        state.following.pagination.page = 1;
    }).addCase(effects.getMutualFollower.pending, function(state, action) {
        var ref;
        state.mutualFollower.isLoading = true;
        state.mutualFollower.error = null;
        var userid = action.meta.arg.userid;
        if (!((ref = state.mutualFollower.user) === null || ref === void 0 ? void 0 : ref[userid])) {
            state.mutualFollower.user[userid] = {
                data: [],
                total_follower: 0
            };
        }
    }).addCase(effects.getMutualFollower.fulfilled, function(state, action) {
        var ref, ref1;
        var _arg = action.meta.arg, userid = _arg.userid, _page = _arg.page, page = _page === void 0 ? 1 : _page;
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (error) {
            state.mutualFollower.error = error;
        } else {
            var users = data.user || [];
            state.mutualFollower.user[userid].data = page > 1 ? (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(state.mutualFollower.user[userid].data).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(users)) : users;
            state.mutualFollower.user[userid].total_follower = data.total_follower;
        }
        state.mutualFollower.isLoading = false;
        state.mutualFollower.message = message;
        state.mutualFollower.pagination.more = ((ref = state.mutualFollower.user[userid]) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.length) < (data === null || data === void 0 ? void 0 : data.total_follower);
        state.mutualFollower.pagination.page = page + 1;
    }).addCase(effects.getMutualFollower.rejected, function(state, action) {
        state.mutualFollower.isLoading = false;
        state.mutualFollower.error = action.payload.error;
        state.mutualFollower.pagination.more = false;
        state.mutualFollower.pagination.page = 1;
    });
};
var moderationSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSlice */ .oM)({
    name: "moderation",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (moderationSlice);


/***/ }),

/***/ 47225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ slice; },
  "Sz": function() { return /* binding */ StreamWidget_slice_effects; },
  "wl": function() { return /* binding */ selectors; }
});

// UNUSED EXPORTS: initialState

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./src/global/StreamWidget/constants.ts
var constants = __webpack_require__(21390);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/utils/auth.js
var auth = __webpack_require__(14229);
// EXTERNAL MODULE: ./src/lib/api/stream.ts
var api_stream = __webpack_require__(51679);
// EXTERNAL MODULE: ./src/lib/api/watchlist.ts
var watchlist = __webpack_require__(15056);
// EXTERNAL MODULE: ./src/lib/api/research.ts
var research = __webpack_require__(47752);
// EXTERNAL MODULE: ./src/global/AlertMessage/index.tsx
var AlertMessage = __webpack_require__(6430);
// EXTERNAL MODULE: ./src/constants/successMessage.js
var successMessage = __webpack_require__(41208);
// EXTERNAL MODULE: ./src/utils/stream.js
var utils_stream = __webpack_require__(14601);
;// CONCATENATED MODULE: ./src/global/StreamWidget/slice/slice.effects.ts
/* eslint-disable @typescript-eslint/ban-ts-comment */ /* eslint-disable no-undef */ 





// related stores

// api







var _obj;
var STREAM_API = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constants/* STREAM_TYPE.GENERIC */.R5.GENERIC, api_stream/* default.getStream */.Z.getStream), (0,_define_property/* default */.Z)(_obj, constants/* STREAM_TYPE.USER */.R5.USER, api_stream/* default.getUserStream */.Z.getUserStream), (0,_define_property/* default */.Z)(_obj, constants/* STREAM_TYPE.SYMBOL */.R5.SYMBOL, api_stream/* default.getSymbolStream */.Z.getSymbolStream), _obj);
// Actions ---------------------------------------------------------------------
// types
var CONTEXT = "@redux/streamWidget";
var actionType = {
    GET_STREAM: "".concat(CONTEXT, "/get_stream"),
    GET_RESEARCH: "".concat(CONTEXT, "/get_research"),
    LOAD_MORE_STREAM: "".concat(CONTEXT, "/load_more_stream"),
    LIKE_POST: "".concat(CONTEXT, "/like_post"),
    UNLIKE_POST: "".concat(CONTEXT, "/unlike_post"),
    POST_VOTE_TARGET_PRICE: "".concat(CONTEXT, "/vote_target_price"),
    POST_VOTE_POLLING: "".concat(CONTEXT, "/vote_polling"),
    FOLLOW_POST: "".concat(CONTEXT, "/follow_post"),
    UNFOLLOW_POST: "".concat(CONTEXT, "/unfollow_post"),
    SAVE_POST: "".concat(CONTEXT, "/save_post"),
    UNSAVE_POST: "".concat(CONTEXT, "/unsave_post"),
    GET_ANNOUNCEMENT_REPORTS: "".concat(CONTEXT, "/get_announcement_reports"),
    POST_REPORT_STREAM: "".concat(CONTEXT, "/post_report_stream"),
    DELETE_POST: "".concat(CONTEXT, "/delete_post"),
    DELETE_MULTIPLE_POST: "".concat(CONTEXT, "/delete_multiple_post"),
    PIN_POST: "".concat(CONTEXT, "/pin_post"),
    UNPIN_POST: "".concat(CONTEXT, "/unpin_post"),
    GET_STREAM_LIKERS: "".concat(CONTEXT, "/get_liker_post"),
    FOLLOW_STREAM_LIKERS: "".concat(CONTEXT, "/follow_liker_post"),
    CHANGE_COMMENTER_TYPE: "".concat(CONTEXT, "/CHANGE_COMMENTER_TYPE"),
    GET_RESEARCH_INDICATOR: "".concat(CONTEXT, "/GET_RESEARCH_INDICATOR"),
    UNTAG_POST: "".concat(CONTEXT, "/UNTAG_POST"),
    GET_COMPANY_PINNED_POST: "".concat(CONTEXT, "/get_pinned_post")
};
// effects
var effects = {
    likePost: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.LIKE_POST, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var postid, response, _data, _$error, data, ref, ref1, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    postid = _args.length > 0 && _args[0] !== void 0 ? _args[0] : null;
                    _ctx.prev = 1;
                    if (postid) {
                        _ctx.next = 4;
                        break;
                    }
                    throw new Error("Post id can't be null");
                case 4:
                    _ctx.next = 6;
                    return api_stream/* default.likeStreamPost */.Z.likeStreamPost(postid);
                case 6:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 9;
                        break;
                    }
                    throw new Error("Attempt to like post failed");
                case 9:
                    _data = response.data, _$error = _data.error, data = _data.data;
                    if (!_$error) {
                        _ctx.next = 12;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        error: _$error
                    });
                case 12:
                    return _ctx.abrupt("return", {
                        postid: postid,
                        data: data
                    });
                case 15:
                    _ctx.prev = 15;
                    _ctx.t0 = _ctx["catch"](1);
                    ;
                    if (!(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref = _ctx.t0.cause) === null || ref === void 0 ? void 0 : ref.message)) {
                        _ctx.next = 21;
                        break;
                    }
                    ;
                    return _ctx.abrupt("return", {
                        error: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref1 = _ctx.t0.cause) === null || ref1 === void 0 ? void 0 : ref1.message
                    });
                case 21:
                    return _ctx.abrupt("return", {
                        error: _ctx.t0.message
                    });
                case 22:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                15
            ]
        ]);
    }))),
    unlikePost: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.UNLIKE_POST, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var postid, response, _data, _$error, data, ref, ref1, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    postid = _args.length > 0 && _args[0] !== void 0 ? _args[0] : null;
                    _ctx.prev = 1;
                    if (postid) {
                        _ctx.next = 4;
                        break;
                    }
                    throw new Error("Post id can't be null");
                case 4:
                    _ctx.next = 6;
                    return api_stream/* default.unlikeStreamPost */.Z.unlikeStreamPost(postid);
                case 6:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 9;
                        break;
                    }
                    throw new Error("Attempt to unlike post failed");
                case 9:
                    _data = response.data, _$error = _data.error, data = _data.data;
                    if (!_$error) {
                        _ctx.next = 12;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        error: _$error
                    });
                case 12:
                    return _ctx.abrupt("return", {
                        postid: postid,
                        data: data
                    });
                case 15:
                    _ctx.prev = 15;
                    _ctx.t0 = _ctx["catch"](1);
                    ;
                    if (!(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref = _ctx.t0.cause) === null || ref === void 0 ? void 0 : ref.message)) {
                        _ctx.next = 21;
                        break;
                    }
                    ;
                    return _ctx.abrupt("return", {
                        error: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref1 = _ctx.t0.cause) === null || ref1 === void 0 ? void 0 : ref1.message
                    });
                case 21:
                    return _ctx.abrupt("return", {
                        error: _ctx.t0.message
                    });
                case 22:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                15
            ]
        ]);
    }))),
    getStream: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_STREAM, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(_param) {
            var _type, type, _category, category, _streamType, streamType, _username, username, _symbol, symbol, keyword, rest, API_VERSION, targetAPI, firstParam, clean, response, _data, data, message, _$error, errorType, streams;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _type = _param.type, type = _type === void 0 ? "all" : _type, _category = _param.category, category = _category === void 0 ? "latest" : _category, _streamType = _param.streamType, streamType = _streamType === void 0 ? constants/* STREAM_TYPE.GENERIC */.R5.GENERIC : _streamType, _username = _param.username, username = _username === void 0 ? "" : _username, _symbol = _param.symbol, symbol = _symbol === void 0 ? "" : _symbol, keyword = _param.keyword, rest = (0,_object_without_properties/* default */.Z)(_param, [
                            "type",
                            "category",
                            "streamType",
                            "username",
                            "symbol",
                            "keyword"
                        ]);
                        _ctx.prev = 1;
                        API_VERSION = constants/* STREAM_VERSION.V3 */.hD.V3;
                        targetAPI = STREAM_API[streamType];
                        firstParam = API_VERSION;
                        if (!(streamType === constants/* STREAM_TYPE.USER */.R5.USER)) {
                            _ctx.next = 9;
                            break;
                        }
                        if (username) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error("Username is required");
                    case 8:
                        firstParam = username;
                    case 9:
                        if (!(streamType === constants/* STREAM_TYPE.SYMBOL */.R5.SYMBOL)) {
                            _ctx.next = 13;
                            break;
                        }
                        if (symbol) {
                            _ctx.next = 12;
                            break;
                        }
                        throw new Error("Symbol is required");
                    case 12:
                        firstParam = symbol;
                    case 13:
                        clean = keyword && keyword === "" ? null : 0;
                        _ctx.next = 16;
                        return targetAPI(firstParam, (0,_object_spread/* default */.Z)({
                            type: type,
                            category: category,
                            clean: clean,
                            keyword: keyword
                        }, rest));
                    case 16:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 19;
                            break;
                        }
                        throw new Error("Attempt to fetch stream failed");
                    case 19:
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error, errorType = _data.error_type;
                        if (!(_$error || errorType)) {
                            _ctx.next = 22;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: errorType || _$error
                        });
                    case 22:
                        streams = (0,utils_stream/* transformV3Response */.bv)(data.stream);
                        return _ctx.abrupt("return", {
                            data: streams,
                            message: message
                        });
                    case 26:
                        _ctx.prev = 26;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 29:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    26
                ]
            ]);
        }));
        return function(_param) {
            return _ref.apply(this, arguments);
        };
    }()),
    getResearchStream: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_RESEARCH, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(params) {
            var response, _data, data, message, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,research/* getResearchData */.RJ)(params);
                    case 2:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 5;
                            break;
                        }
                        throw new Error("Attempt to fetch stream research failed");
                    case 5:
                        _data = response.data, data = _data.data, message = _data.message, error = _data.error_type;
                        if (!error) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error(message);
                    case 8:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            loadMore: !!params.last_id
                        });
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }()),
    loadMoreStream: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.LOAD_MORE_STREAM, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(_param) {
            var _type, type, _category, category, _streamType, streamType, _username, username, _symbol, symbol, _lastpost, lastpost, _beforetimestamp, beforetimestamp, keyword, rest, API_VERSION, targetAPI, firstParam, clean, response, _data, data, message, _$error, errorType, streams;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _type = _param.type, type = _type === void 0 ? "all" : _type, _category = _param.category, category = _category === void 0 ? "latest" : _category, _streamType = _param.streamType, streamType = _streamType === void 0 ? constants/* STREAM_TYPE.GENERIC */.R5.GENERIC : _streamType, _username = _param.username, username = _username === void 0 ? "" : _username, _symbol = _param.symbol, symbol = _symbol === void 0 ? "" : _symbol, _lastpost = _param.lastpost, lastpost = _lastpost === void 0 ? 0 : _lastpost, _beforetimestamp = _param.beforetimestamp, beforetimestamp = _beforetimestamp === void 0 ? 0 : _beforetimestamp, keyword = _param.keyword, rest = (0,_object_without_properties/* default */.Z)(_param, [
                            "type",
                            "category",
                            "streamType",
                            "username",
                            "symbol",
                            "lastpost",
                            "beforetimestamp",
                            "keyword"
                        ]);
                        _ctx.prev = 1;
                        API_VERSION = constants/* STREAM_VERSION.V3 */.hD.V3;
                        targetAPI = STREAM_API[streamType];
                        firstParam = API_VERSION;
                        if (!(streamType === constants/* STREAM_TYPE.USER */.R5.USER)) {
                            _ctx.next = 9;
                            break;
                        }
                        if (username) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error("Username is required");
                    case 8:
                        firstParam = username;
                    case 9:
                        if (!(streamType === constants/* STREAM_TYPE.SYMBOL */.R5.SYMBOL)) {
                            _ctx.next = 13;
                            break;
                        }
                        if (symbol) {
                            _ctx.next = 12;
                            break;
                        }
                        throw new Error("Symbol is required");
                    case 12:
                        firstParam = symbol;
                    case 13:
                        clean = keyword && keyword === "" ? null : 0;
                        _ctx.next = 16;
                        return targetAPI(firstParam, (0,_object_spread/* default */.Z)({
                            type: type,
                            category: category,
                            clean: clean,
                            keyword: keyword,
                            beforelastpost: 1,
                            lastpost: lastpost,
                            beforetimestamp: beforetimestamp
                        }, rest));
                    case 16:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 19;
                            break;
                        }
                        throw new Error("Attempt to fetch stream failed");
                    case 19:
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error, errorType = _data.error_type;
                        if (!(_$error || errorType)) {
                            _ctx.next = 22;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: errorType || _$error
                        });
                    case 22:
                        streams = (0,utils_stream/* transformV3Response */.bv)(data.stream);
                        return _ctx.abrupt("return", {
                            data: streams,
                            message: message
                        });
                    case 26:
                        _ctx.prev = 26;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 29:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    26
                ]
            ]);
        }));
        return function(_param) {
            return _ref.apply(this, arguments);
        };
    }()),
    postVoteTargetPrice: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.POST_VOTE_TARGET_PRICE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var targetPriceId, agree, response, _data, data, message, _$error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        targetPriceId = param.targetPriceId, agree = param.agree;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return api_stream/* default.postVoteTargetPrice */.Z.postVoteTargetPrice(targetPriceId, agree);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to vote target price failed");
                    case 7:
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    postVotePolling: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.POST_VOTE_POLLING, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var pollingId, optionId, response, _data, data, message, _$error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        pollingId = param.pollingId, optionId = param.optionId;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return api_stream/* default.postPollingVote */.Z.postPollingVote(pollingId, optionId);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to vote polling failed");
                    case 7:
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.cause
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    followPost: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.FOLLOW_POST, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(postid) {
            var response, _data, data, _$error, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return api_stream/* default.followPost */.Z.followPost(postid);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to follow post failed");
                    case 6:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            postid: postid
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(postid) {
            return _ref.apply(this, arguments);
        };
    }()),
    unfollowPost: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.UNFOLLOW_POST, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(postid) {
            var response, _data, data, _$error, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return api_stream/* default.unfollowPost */.Z.unfollowPost(postid);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to unfollow post failed");
                    case 6:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            postid: postid
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(postid) {
            return _ref.apply(this, arguments);
        };
    }()),
    // save/unsave post
    savePost: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.SAVE_POST, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(postid) {
            var response, _data, data, _$error, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return api_stream/* default.savePost */.Z.savePost(postid);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to save post failed");
                    case 6:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            postid: postid
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(postid) {
            return _ref.apply(this, arguments);
        };
    }()),
    unsavePost: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.UNSAVE_POST, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(postid) {
            var response, _data, _$error, message, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return api_stream/* default.unsavePost */.Z.unsavePost(postid);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to unsave post failed");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            postid: postid
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(postid) {
            return _ref.apply(this, arguments);
        };
    }()),
    // get announcement reports
    getAnnouncementReports: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_ANNOUNCEMENT_REPORTS, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(postid) {
            var response, _data, _$error, message, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return api_stream/* default.getAnnouncementReports */.Z.getAnnouncementReports(postid);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to get announcement report failed!");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            postid: postid
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(postid) {
            return _ref.apply(this, arguments);
        };
    }()),
    postReportStream: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.POST_REPORT_STREAM, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var postid, type, message, response, _data, _$error, data, resMessage;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        postid = param.postid, type = param.type, message = param.message;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return api_stream/* default.postReportStream */.Z.postReportStream(postid, type, message);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to report stream post failed");
                    case 7:
                        _data = response.data, _$error = _data.error, data = _data.data, resMessage = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: resMessage
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: resMessage
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    deleteStreamPost: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.DELETE_POST, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var postid, reason, sendEmail, isAuthor, type, response, _data, _$error, error_type, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        postid = param.postid, reason = param.reason, sendEmail = param.sendEmail, isAuthor = param.isAuthor, type = param.type;
                        _ctx.prev = 1;
                        response = null;
                        if (!isAuthor) {
                            _ctx.next = 9;
                            break;
                        }
                        _ctx.next = 6;
                        return api_stream/* default.deleteOwnPostStream */.Z.deleteOwnPostStream(postid);
                    case 6:
                        response = _ctx.sent;
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.next = 11;
                        return api_stream/* default.deletePostStream */.Z.deletePostStream(postid, reason, sendEmail);
                    case 11:
                        response = _ctx.sent;
                    case 12:
                        if (response.data) {
                            _ctx.next = 14;
                            break;
                        }
                        throw new Error("Attempt to delete post failed");
                    case 14:
                        _data = response.data, _$error = _data.error, error_type = _data.error_type, data = _data.data, message = _data.message;
                        if (!(_$error || error_type)) {
                            _ctx.next = 17;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error || error_type,
                            message: message
                        });
                    case 17:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 20:
                        _ctx.prev = 20;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 23:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    20
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    deleteMultipleStreamPost: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.DELETE_MULTIPLE_POST, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var userid, reason, sendEmail, time, response, _data, _$error, error_type, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        userid = param.userid, reason = param.reason, sendEmail = param.sendEmail, time = param.time;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return api_stream/* default.deleteMultiplePostStream */.Z.deleteMultiplePostStream(userid, time, reason, sendEmail);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to delete post failed");
                    case 7:
                        _data = response.data, _$error = _data.error, error_type = _data.error_type, data = _data.data, message = _data.message;
                        if (!(_$error || error_type)) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error || error_type,
                            message: message
                        });
                    case 10:
                        (0,AlertMessage/* default */.Z)({
                            content: successMessage/* default.DELETE_STREAM_MULTIPLE_SUCCESSFUL */.Z.DELETE_STREAM_MULTIPLE_SUCCESSFUL,
                            alertType: "snackbar",
                            messageType: "success",
                            hasCloseIcon: true
                        });
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    14
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    pinPost: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.PIN_POST, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var postid, _symbol, symbol, response, _data, _$error, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        postid = param.postid, _symbol = param.symbol, symbol = _symbol === void 0 ? null : _symbol;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return api_stream/* default.pinPost */.Z.pinPost(postid, symbol);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to pin post failed");
                    case 7:
                        _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    unpinPost: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.UNPIN_POST, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var postid, _symbol, symbol, response, _data, _$error, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        postid = param.postid, _symbol = param.symbol, symbol = _symbol === void 0 ? null : _symbol;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return api_stream/* default.unpinPost */.Z.unpinPost(postid, symbol);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to pin post failed");
                    case 7:
                        _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getStreamLikers: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_STREAM_LIKERS, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var postid, page, username, response, _data, _$error, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        postid = param.postid, page = param.page;
                        _ctx.prev = 1;
                        username = auth/* default.getUserAccess */.Z.getUserAccess().username;
                        _ctx.next = 5;
                        return api_stream/* default.getStreamLikers */.Z.getStreamLikers(username, postid, page);
                    case 5:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error("Attempt to get stream likers failed");
                    case 8:
                        _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 11;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 11:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            page: page,
                            postid: postid
                        });
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    14
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    followStreamLikers: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.FOLLOW_STREAM_LIKERS, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var postid, userid, type, ref, watchListId, targetAPI, response, _$error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        postid = param.postid, userid = param.userid, type = param.type;
                        _ctx.prev = 1;
                        ref = auth/* default.getUserAccess */.Z.getUserAccess(), watchListId = ref.watchlist_id;
                        if (watchListId) {
                            _ctx.next = 5;
                            break;
                        }
                        throw new Error("Watchlist id is empty");
                    case 5:
                        if (userid) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("User id is empty");
                    case 7:
                        targetAPI = watchlist/* default.postFollowUser */.Z.postFollowUser;
                        if (type === "UNFOLLOW") {
                            targetAPI = watchlist/* default.postUnfollowUser */.Z.postUnfollowUser;
                        }
                        _ctx.next = 11;
                        return targetAPI(userid);
                    case 11:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 14;
                            break;
                        }
                        throw new Error("Attempt to follow user failed");
                    case 14:
                        _$error = response.data.error;
                        if (!_$error) {
                            _ctx.next = 17;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error
                        });
                    case 17:
                        return _ctx.abrupt("return", {
                            type: type,
                            userid: userid,
                            postid: postid
                        });
                    case 20:
                        _ctx.prev = 20;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 23:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    20
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    changeCommenter: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.CHANGE_COMMENTER_TYPE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var type, postid, response, _data, _$error, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        type = param.type, postid = param.postid;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return api_stream/* default.changeCommenterType */.Z.changeCommenterType(type, postid);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to change commenter type failed");
                    case 7:
                        _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getResearchIndicator: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_RESEARCH_INDICATOR, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(symbol) {
            var response, _data, _$error, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return (0,research/* getResearchIndicator */.Ht)(symbol);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to get research indicator failed");
                    case 6:
                        _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(symbol) {
            return _ref.apply(this, arguments);
        };
    }()),
    // untag post
    untagPost: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.UNTAG_POST, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(postId) {
            var response, _data, _$error, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return api_stream/* default.untagPostTopic */.Z.untagPostTopic(postId);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to untag post topic failed");
                    case 6:
                        _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        (0,AlertMessage/* default */.Z)({
                            content: successMessage/* default.UNTAG_POST_SUCCESSFUL */.Z.UNTAG_POST_SUCCESSFUL,
                            alertType: "snackbar",
                            messageType: "success",
                            hasCloseIcon: true
                        });
                        return _ctx.abrupt("return", {
                            data: data,
                            error: _$error
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }));
        return function(postId) {
            return _ref.apply(this, arguments);
        };
    }()),
    // get pinned post
    getCompanyPinnedPost: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_COMPANY_PINNED_POST, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(symbol) {
            var response, _data, _$error, data, message, stream;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        if (symbol) {
                            _ctx.next = 3;
                            break;
                        }
                        throw new Error("Symbol is required!");
                    case 3:
                        _ctx.next = 5;
                        return api_stream/* default.getCompanyPinnedPost */.Z.getCompanyPinnedPost(symbol);
                    case 5:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error("Attempt to get company pinned post failed");
                    case 8:
                        _data = response.data, _$error = _data.error_type, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 11;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 11:
                        stream = (0,utils_stream/* transformStreamV3 */.hp)(data);
                        return _ctx.abrupt("return", {
                            data: stream,
                            message: message,
                            symbol: symbol
                        });
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    15
                ]
            ]);
        }));
        return function(symbol) {
            return _ref.apply(this, arguments);
        };
    }())
};
/* harmony default export */ var slice_effects = (effects);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/constants/errorMessage.js
var errorMessage = __webpack_require__(61608);
;// CONCATENATED MODULE: ./src/global/StreamWidget/slice/slice.extra-reducer.ts



// related stores





var STATUS_FOLLOWING = 1;
var STATUS_UNFOLLOWING = 0;
var STATUS_SAVED = 1;
var STATUS_UNSAVED = 0;
var STATUS_TRENDING = 1;
var STATUS_NOT_TRENDING = 0;
var extraReducers = function(builder) {
    builder// Get and load more stream --------------------------------------------------
    .addCase(slice_effects.getStream.pending, function(state) {
        state.isLoading = true;
        state.error = null;
        state.list = [];
    }).addCase(slice_effects.getStream.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error;
        if (error) {
            state.error = error;
        } else {
            state.list = data;
            state.error = null;
            state.newPostCount = 0;
        }
        state.message = message;
        state.isLoading = false;
    }).addCase(slice_effects.getStream.rejected, function(state, action) {
        state.error = action.payload.error;
        state.isLoading = false;
    }).addCase(slice_effects.loadMoreStream.pending, function(state) {
        state.isLoadingMore = true;
        state.error = null;
    }).addCase(slice_effects.loadMoreStream.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error, message = _payload.message;
        if (error) {
            state.error = error;
        } else {
            state.error = null;
            var currentList = state.list.map(function(i) {
                return (0,_object_spread/* default */.Z)({}, i);
            });
            var newList = (0,_to_consumable_array/* default */.Z)(currentList).concat((0,_to_consumable_array/* default */.Z)(data));
            state.list = newList;
        }
        state.message = message;
        state.isLoadingMore = false;
    }).addCase(slice_effects.loadMoreStream.rejected, function(state, action) {
        state.error = action.payload.error;
        state.isLoadingMore = false;
    })// Get stream research
    .addCase(slice_effects.getResearchStream.pending, function(state, action) {
        var _arg = action.meta.arg, lastId = _arg.last_id;
        if (lastId) {
            state.isLoadingMore = true;
        } else {
            state.isLoading = true;
            state.error = null;
            state.listResearch = [];
        }
    }).addCase(slice_effects.getResearchStream.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message, loadMore = _payload.loadMore;
        if (error) {
            state.error = error;
        }
        if (!loadMore) {
            state.listResearch = data;
        } else {
            var _listResearch;
            (_listResearch = state.listResearch).push.apply(_listResearch, (0,_to_consumable_array/* default */.Z)(data));
        }
        state.message = message;
        state.isLoading = false;
        state.isLoadingMore = false;
    }).addCase(slice_effects.getResearchStream.rejected, function(state, action) {
        state.listResearch = [];
        state.isLoading = false;
        state.error = action.payload;
    })// Like post
    .addCase(slice_effects.likePost.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, postid = _payload.postid, data = _payload.data;
        if (error) {
            (0,AlertErrorMessage/* default */.Z)(error, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
        } else {
            var ref;
            var postIdx = state.list.findIndex(function(post) {
                return post.postid === postid;
            });
            if (postIdx > -1) {
                state.list[postIdx].liked = data.liked;
                state.list[postIdx].likes = data.likes;
            }
            if (((ref = state.companyPinnedPost.data) === null || ref === void 0 ? void 0 : ref.postid) === postid) {
                state.companyPinnedPost.data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.companyPinnedPost.data), {
                    liked: data.liked,
                    likes: data.likes
                });
            }
        }
    })// Unlike post
    .addCase(slice_effects.unlikePost.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, postid = _payload.postid, data = _payload.data;
        if (error) {
            (0,AlertErrorMessage/* default */.Z)(error, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
        } else {
            var ref;
            var postIdx = state.list.findIndex(function(post) {
                return post.postid === postid;
            });
            if (postIdx > -1) {
                state.list[postIdx].liked = data.liked;
                state.list[postIdx].likes = data.likes;
            }
            if (((ref = state.companyPinnedPost.data) === null || ref === void 0 ? void 0 : ref.postid) === postid) {
                state.companyPinnedPost.data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.companyPinnedPost.data), {
                    liked: data.liked,
                    likes: data.likes
                });
            }
        }
    })// Vote target price ---------------------------------------------------------
    .addCase(slice_effects.postVoteTargetPrice.pending, function(state) {
        state.postVoteTargetPrice.isLoading = true;
        state.postVoteTargetPrice.error = null;
    }).addCase(slice_effects.postVoteTargetPrice.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        var postid = action.meta.arg.postid;
        if (error) {
            state.postVoteTargetPrice.error = error;
        } else {
            var ref;
            state.postVoteTargetPrice.error = null;
            // update state list
            var postIdx = state.list.findIndex(function(post) {
                return post.postid === data.postid;
            });
            if (postIdx > -1) {
                state.list[postIdx] = data;
            }
            if (((ref = state.companyPinnedPost.data) === null || ref === void 0 ? void 0 : ref.postid) === postid) {
                state.companyPinnedPost.data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.companyPinnedPost.data), {
                    target_price: data === null || data === void 0 ? void 0 : data.target_price
                });
            }
        }
        state.postVoteTargetPrice.message = message;
        state.postVoteTargetPrice.isLoading = false;
    }).addCase(slice_effects.postVoteTargetPrice.rejected, function(state, action) {
        state.postVoteTargetPrice.error = action.payload.error;
        state.postVoteTargetPrice.isLoading = false;
    })// Vote polling --------------------------------------------------------------
    .addCase(slice_effects.postVotePolling.pending, function(state) {
        state.postVotePolling.isLoading = true;
        state.postVotePolling.error = null;
    }).addCase(slice_effects.postVotePolling.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error;
        var postid = action.meta.arg.postid;
        if (error) {
            state.postVotePolling.error = error;
        } else {
            var ref;
            state.postVotePolling.error = null;
            var postIdx = state.list.findIndex(function(post) {
                return post.polling.length > 0 && post.polling[0].id === data.id;
            });
            if (postIdx > -1) {
                state.list[postIdx].polling[0] = data;
            }
            if (((ref = state.companyPinnedPost.data) === null || ref === void 0 ? void 0 : ref.postid) === postid) {
                state.companyPinnedPost.data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.companyPinnedPost.data), {
                    polling: [
                        data
                    ]
                });
            }
        }
        state.postVotePolling.message = message;
        state.postVotePolling.isLoading = false;
    }).addCase(slice_effects.postVotePolling.rejected, function(state, action) {
        state.postVotePolling.error = action.payload.error;
        state.postVotePolling.isLoading = false;
    })// Follow/unfollow post -------------------------------------------------------
    .addCase(slice_effects.followPost.pending, function(state) {
        state.toggleFollowPost.isLoading = true;
        state.toggleFollowPost.error = null;
    }).addCase(slice_effects.followPost.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error, message = _payload.message, postid = _payload.postid;
        if (error) {
            state.toggleFollowPost.error = error;
        } else {
            var ref;
            state.toggleFollowPost.data = data;
            state.toggleFollowPost.error = null;
            var postIdx = state.list.findIndex(function(post) {
                return post.postid === postid;
            });
            if (postIdx > -1) {
                state.list[postIdx].follow = STATUS_FOLLOWING;
            }
            if (((ref = state.companyPinnedPost.data) === null || ref === void 0 ? void 0 : ref.postid) === postid) {
                state.companyPinnedPost.data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.companyPinnedPost.data), {
                    follow: STATUS_FOLLOWING
                });
            }
        }
        state.toggleFollowPost.isLoading = false;
        state.toggleFollowPost.message = message;
    }).addCase(slice_effects.followPost.rejected, function(state, action) {
        state.toggleFollowPost.error = action.payload.error;
        state.toggleFollowPost.isLoading = false;
    }).addCase(slice_effects.unfollowPost.pending, function(state) {
        state.toggleFollowPost.isLoading = true;
        state.toggleFollowPost.error = null;
    }).addCase(slice_effects.unfollowPost.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error, message = _payload.message, postid = _payload.postid;
        if (error) {
            state.toggleFollowPost.error = error;
        } else {
            var ref;
            state.toggleFollowPost.data = data;
            state.toggleFollowPost.error = null;
            var postIdx = state.list.findIndex(function(post) {
                return post.postid === postid;
            });
            if (postIdx > -1) {
                state.list[postIdx].follow = STATUS_UNFOLLOWING;
            }
            if (((ref = state.companyPinnedPost.data) === null || ref === void 0 ? void 0 : ref.postid) === postid) {
                state.companyPinnedPost.data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.companyPinnedPost.data), {
                    follow: STATUS_UNFOLLOWING
                });
            }
        }
        state.toggleFollowPost.isLoading = false;
        state.toggleFollowPost.message = message;
    }).addCase(slice_effects.unfollowPost.rejected, function(state, action) {
        state.toggleFollowPost.error = action.payload.error;
        state.toggleFollowPost.isLoading = false;
    })// Save/unsave post -------------------------------------------------------
    .addCase(slice_effects.savePost.pending, function(state) {
        state.toggleSavePost.isLoading = true;
        state.toggleSavePost.error = null;
    }).addCase(slice_effects.savePost.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, postid = _payload.postid, data = _payload.data;
        if (error) {
            state.toggleSavePost.error = error;
        } else {
            var ref;
            state.toggleSavePost.data = data;
            state.toggleSavePost.error = null;
            var postIdx = state.list.findIndex(function(post) {
                return post.postid === postid;
            });
            if (postIdx > -1) {
                state.list[postIdx].saved = STATUS_SAVED;
            }
            if (((ref = state.companyPinnedPost.data) === null || ref === void 0 ? void 0 : ref.postid) === postid) {
                state.companyPinnedPost.data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.companyPinnedPost.data), {
                    saved: STATUS_SAVED
                });
            }
        }
        state.toggleSavePost.message = message;
        state.toggleSavePost.isLoading = false;
    }).addCase(slice_effects.savePost.rejected, function(state, action) {
        state.toggleSavePost.error = action.payload.error;
        state.toggleSavePost.isLoading = false;
    }).addCase(slice_effects.unsavePost.pending, function(state) {
        state.toggleSavePost.isLoading = true;
        state.toggleSavePost.error = null;
    }).addCase(slice_effects.unsavePost.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, postid = _payload.postid, data = _payload.data;
        if (error) {
            state.toggleSavePost.error = error;
        } else {
            var ref;
            state.toggleSavePost.data = data;
            state.toggleSavePost.error = null;
            var postIdx = state.list.findIndex(function(post) {
                return post.postid === postid;
            });
            if (postIdx > -1) {
                state.list[postIdx].saved = STATUS_UNSAVED;
            }
            if (((ref = state.companyPinnedPost.data) === null || ref === void 0 ? void 0 : ref.postid) === postid) {
                state.companyPinnedPost.data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.companyPinnedPost.data), {
                    saved: STATUS_UNSAVED
                });
            }
        }
        state.toggleSavePost.message = message;
        state.toggleSavePost.isLoading = false;
    }).addCase(slice_effects.unsavePost.rejected, function(state, action) {
        state.toggleSavePost.error = action.payload.error;
        state.toggleSavePost.isLoading = false;
    })// Get announcement reports --------------------------------------------------
    .addCase(slice_effects.getAnnouncementReports.pending, function(state) {
        state.announcementReports.isLoading = true;
        state.announcementReports.error = null;
    }).addCase(slice_effects.getAnnouncementReports.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message, postid = _payload.postid;
        if (error) {
            state.announcementReports.error = error;
        } else {
            state.announcementReports[postid] = data;
        }
        state.announcementReports.message = message;
        state.announcementReports.isLoading = false;
    }).addCase(slice_effects.getAnnouncementReports.rejected, function(state, action) {
        state.announcementReports.error = action.payload.error;
        state.announcementReports.isLoading = false;
    })// Pin unpin post ------------------------------------------------------------
    .addCase(slice_effects.pinPost.pending, function(state) {
        state.togglePinPost.isLoading = true;
        state.togglePinPost.error = null;
    }).addCase(slice_effects.pinPost.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (error) {
            state.togglePinPost.error = error;
        } else {
            (0,AlertMessage/* default */.Z)({
                content: successMessage/* default.POST_PINNED_SUCCESSFUL */.Z.POST_PINNED_SUCCESSFUL,
                alertType: "snackbar",
                messageType: "success",
                hasCloseIcon: true
            });
            state.togglePinPost.data = data;
        }
        state.togglePinPost.isLoading = false;
        state.togglePinPost.message = message;
    }).addCase(slice_effects.pinPost.rejected, function(state, action) {
        state.togglePinPost.error = action.payload.error;
        state.togglePinPost.isLoading = false;
    }).addCase(slice_effects.unpinPost.pending, function(state) {
        state.togglePinPost.isLoading = true;
        state.togglePinPost.error = null;
    }).addCase(slice_effects.unpinPost.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (error) {
            state.togglePinPost.error = error;
        } else {
            (0,AlertMessage/* default */.Z)({
                content: successMessage/* default.POST_UNPINNED_SUCCESSFUL */.Z.POST_UNPINNED_SUCCESSFUL,
                alertType: "snackbar",
                messageType: "success",
                hasCloseIcon: true
            });
            state.togglePinPost.data = data;
        }
        state.togglePinPost.isLoading = false;
        state.togglePinPost.message = message;
    }).addCase(slice_effects.unpinPost.rejected, function(state, action) {
        state.togglePinPost.error = action.payload.error;
        state.togglePinPost.isLoading = false;
    })// Report stream doesn't affect reducer, extra reducer for this is unnecessary
    // Get stream likers ---------------------------------------------------------
    .addCase(slice_effects.getStreamLikers.pending, function(state) {
        state.streamLikers.isLoading = true;
        state.streamLikers.error = null;
    }).addCase(slice_effects.getStreamLikers.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data, page = _payload.page, postid = _payload.postid;
        if (error) {
            state.streamLikers.error = error;
        } else {
            // eslint-disable-next-line no-lonely-if
            if (page > 1) {
                var currentList = state.streamLikers.data[postid].likers.map(function(s) {
                    return (0,_object_spread/* default */.Z)({}, s);
                });
                var newList = (0,_to_consumable_array/* default */.Z)(currentList).concat((0,_to_consumable_array/* default */.Z)(data.likers));
                state.streamLikers.data[postid].likers = newList;
                state.streamLikers.data[postid].data = newList;
                state.streamLikers.data[postid].more = data.more;
            } else {
                state.streamLikers.data[postid] = data;
            }
        }
        state.streamLikers.message = message;
        state.streamLikers.isLoading = false;
    }).addCase(slice_effects.getStreamLikers.rejected, function(state, action) {
        state.streamLikers.error = action.payload.error;
        state.streamLikers.isLoading = false;
    })// Follow stream likers
    .addCase(slice_effects.followStreamLikers.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, type = _payload.type, postid = _payload.postid, userid = _payload.userid;
        if (!error && state.streamLikers.data[postid]) {
            var ref;
            var userIdx = (ref = state.streamLikers.data[postid].likers) === null || ref === void 0 ? void 0 : ref.findIndex(function(user) {
                return user.id === userid;
            });
            if (userIdx > -1) {
                state.streamLikers.data[postid].likers[userIdx].followed = type === "FOLLOW";
            }
        }
    })// Delete Stream ---------------------------------------------------------
    .addCase(slice_effects.deleteStreamPost.fulfilled, function(state, action) {
        var error = action.payload.error;
        var _arg = action.meta.arg, postid = _arg.postid, type = _arg.type;
        if (!error) {
            var postIdx = state.list.findIndex(function(post) {
                return post.postid === postid;
            });
            (0,AlertMessage/* default */.Z)({
                content: "".concat(successMessage/* default.POST_SUCCESSFUL_DELETED */.Z.POST_SUCCESSFUL_DELETED, " ").concat(type),
                alertType: "snackbar",
                messageType: "success",
                hasCloseIcon: true
            });
            if (postIdx > -1) {
                state.list.splice(postIdx, 1);
            }
        }
    }).addCase(slice_effects.changeCommenter.fulfilled, function(state, action) {
        var error = action.payload.error;
        var _arg = action.meta.arg, postid = _arg.postid, type = _arg.type, label = _arg.label;
        if (!error) {
            var postIdx = state.list.findIndex(function(post) {
                return post.postid === postid;
            });
            var successMessage = "".concat(label, " can comment now");
            (0,AlertMessage/* default */.Z)({
                content: successMessage,
                alertType: "snackbar",
                messageType: "success",
                hasCloseIcon: true
            });
            if (postIdx > -1) {
                state.list[postIdx].commenter_type = type;
            }
        }
    })// Research Indicator
    .addCase(slice_effects.getResearchIndicator.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data;
        if (!error) {
            state.hasNewResearch = data === null || data === void 0 ? void 0 : data.has_new;
            state.newResearchCount = data === null || data === void 0 ? void 0 : data.count;
        }
    })// Get Company Pinned Post
    .addCase(slice_effects.getCompanyPinnedPost.pending, function(state) {
        state.companyPinnedPost.isLoading = true;
        state.companyPinnedPost.error = null;
        state.companyPinnedPost.data = null;
    }).addCase(slice_effects.getCompanyPinnedPost.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data;
        if (error) {
            state.companyPinnedPost.error = error;
        } else {
            state.companyPinnedPost.data = data;
            state.companyPinnedPost.error = null;
        }
        state.companyPinnedPost.message = message;
        state.companyPinnedPost.isLoading = false;
    }).addCase(slice_effects.getCompanyPinnedPost.rejected, function(state, action) {
        state.companyPinnedPost.isLoading = false;
        state.companyPinnedPost.error = action.payload.error;
    });
};
/* harmony default export */ var slice_extra_reducer = (extraReducers);

;// CONCATENATED MODULE: ./src/global/StreamWidget/slice/index.tsx


// api



// initial state
var initialState = {
    list: [],
    listResearch: [],
    newPostCount: 0,
    isLoading: true,
    isLoadingMore: false,
    error: null,
    message: "",
    categories: constants/* categories */.bd,
    types: constants/* streamTypes */.J1,
    tabHeader: constants/* STREAM_TABS.0.value */.q1[0].value,
    selectedCategory: "latest",
    selectedType: "ideas",
    filterParams: {
        type: "latest",
        category: "",
        keyword: "",
        from: "",
        to: "",
        reporttype: null,
        date: null
    },
    postVoteTargetPrice: {
        isLoading: false,
        data: {},
        error: null,
        message: ""
    },
    postVotePolling: {
        data: {},
        isLoading: false,
        error: null,
        message: ""
    },
    toggleFollowPost: {
        data: {},
        isLoading: false,
        error: null,
        message: ""
    },
    toggleSavePost: {
        data: {},
        isLoading: false,
        error: null,
        message: ""
    },
    togglePinPost: {
        data: null,
        isLoading: false,
        error: null,
        message: ""
    },
    announcementReports: {
        data: {},
        isLoading: false,
        error: null,
        message: ""
    },
    streamLikers: {
        data: {},
        isLoading: false,
        error: null,
        message: ""
    },
    companyPinnedPost: {
        data: null,
        isLoading: false,
        error: null,
        message: ""
    },
    hasNewResearch: false,
    newResearchCount: 1
};
// Selectors -------------------------------------------------------------------
var streamWidgetSelector = function(state) {
    return state.streamWidget;
};
var selectors = (0,es/* createSelector */.P1)(streamWidgetSelector, function(state) {
    return (0,_object_spread/* default */.Z)({}, state);
});
// effects
var StreamWidget_slice_effects = slice_effects;
// Reducers ------------------------------------------------------------------
var reducers = {
    changeType: function changeType(state, action) {
        state.selectedType = action.payload;
    },
    changeCategory: function changeCategory(state, action) {
        state.selectedCategory = action.payload;
    },
    setFilterParam: function(state, action) {
        state.filterParams = (0,_object_spread/* default */.Z)({}, state.filterParams, action.payload);
    },
    resetFilterParam: function(state) {
        state.filterParams = initialState.filterParams;
        state.newPostCount = 0;
    },
    addNewPostCount: function(state) {
        state.newPostCount += 1;
    },
    setTabHeader: function(state, action) {
        state.tabHeader = action.payload;
    },
    removeHasNewResearch: function(state) {
        state.hasNewResearch = false;
    }
};
// Extra Reducer ---------------------------------------------------------------
var slice_extraReducers = slice_extra_reducer;
// Slice -----------------------------------------------------------------------
var streamSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "streamWidget",
    initialState: initialState,
    reducers: reducers,
    extraReducers: slice_extraReducers
});
/* harmony default export */ var slice = (streamSlice);


/***/ }),

/***/ 1349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78372);
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68425);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37213);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_5__);








var marketDetectorURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/marketdetectors");
var findataViewURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/findata-view/marketdetectors");
var seasonalityURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/seasonality");
var emittenURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/emitten");
var hotlistURL = "".concat(emittenURL, "/hotlist");
var companyPriceFeedURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/company-price-feed");
var emittenMetadataURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/emitten-metadata");
var orderTradeURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/order-trade");
var requestExodus = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_2__/* ["default"].noAlert */ .Z.noAlert;
// trending
var getTrendingCompany = function() {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/emitten/trending"));
};
var getIHSG = function() {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/emitten/IHSG/info"));
};
var getTendingCompanyPrices = function(param) {
    var symbol = param.symbol, _interval = param.interval, interval = _interval === void 0 ? "5" : _interval;
    if (typeof symbol === "string") {
        return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/company-price-feed/prices/close"), {
            params: {
                interval: interval,
                symbol: symbol
            }
        });
    }
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/company-price-feed/prices/close"), {
        params: {
            interval: interval,
            symbol: symbol
        },
        paramsSerializer: function(params) {
            return qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(params);
        }
    });
};
// Hotlist
var getTopGainer = function() {
    return requestExodus.get("".concat(hotlistURL, "/topgainer?limit=10"));
};
var getTopLoser = function() {
    return requestExodus.get("".concat(hotlistURL, "/toploser?limit=10"));
};
var getMostActive = function() {
    return requestExodus.get("".concat(hotlistURL, "/mostactive?limit=10"));
};
/**
 * Search company with keyword
 */ var getSearchCompany = function(params) {
    return requestExodus.get("/watchlist/search/company", {
        params: params
    });
};
var getCompanyInfo = function(symbol) {
    return requestExodus.get("".concat(emittenURL, "/").concat(symbol, "/info"));
};
/**
 * Get company profile info
 * @param {string} symbol
 * @return {APIResponse}
 */ var getCompanyProfile = function(symbol) {
    return requestExodus.get("".concat(emittenURL, "/").concat(symbol, "/profile"));
};
var getCompanyChart = function(symbol, timeframe) {
    var includePrevious = timeframe === "ytd" || timeframe === "1w";
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/charts/").concat(symbol, "/daily"), {
        params: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            timeframe: timeframe
        }, includePrevious && {
            is_include_previous_historical: true
        })
    });
};
var getMarketDetector = function(symbol, params) {
    return requestExodus.get("".concat(marketDetectorURL, "/").concat(symbol), {
        params: params
    });
};
var getTopBroker = function(params) {
    return requestExodus.get("order-trade/broker/top", {
        params: params
    });
};
var getBrokerList = function(params) {
    return requestExodus.get("".concat(findataViewURL, "/brokers"), {
        params: params
    });
};
var getMarketDetectorActivity = function(brokerCode, params) {
    return requestExodus.get("".concat(findataViewURL, "/activity/").concat(brokerCode, "/detail"), {
        params: params
    });
};
var getAllCorpAction = function(symbol) {
    var limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 30;
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/corpaction/").concat(symbol), {
        params: {
            limit: limit
        }
    });
};
var getCompanyCorpAction = function(symbol, category) {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/corpaction/").concat(category), {
        params: {
            symbol: symbol
        }
    });
};
/**
 * Get company major holder, related to get company insider
 * @param {Object} props
 * @param {string=} props.insider
 * @param {string} props.symbol
 * @param {string=} props.datestart
 * @param {string=} props.dateend
 * @param {number=} props.page
 * @returns {APIResponse}
 */ var getCompanyMajorholder = function(param) {
    var _insider = param.insider, insider = _insider === void 0 ? "" : _insider, symbol = param.symbol, _datestart = param.datestart, datestart = _datestart === void 0 ? "" : _datestart, _dateend = param.dateend, dateend = _dateend === void 0 ? "" : _dateend, page = param.page;
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/insider/company/majorholder"), {
        params: {
            insider: insider,
            symbol: symbol,
            date_start: datestart,
            date_end: dateend,
            page: page
        }
    });
};
/**
 * Get company seasonality data
 * @param {string} symbol
 * @param {string|number} year
 * @param {string|number} backyear
 * @return {APIResponse}
 */ var getCompanySeasonality = function(symbol, year, backyear) {
    return requestExodus.get("".concat(seasonalityURL, "/").concat(symbol), {
        params: {
            year: year,
            back_year: backyear
        }
    });
};
var getCompanyKeystat = function(symbol) {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/keystats/ratio/v1/").concat(symbol), {
        params: {
            year_limit: 10
        }
    });
};
/**
 * Get financial reports
 * @param {Object} params
 * @param {string} params.symbol
 * @param {string} params.datatype
 * @param {string} params.reporttype
 * @param {string} params.statement
 * @return {APIResponse}
 */ var getFinancialReport = function(param) {
    var symbol = param.symbol, _datatype = param.datatype, datatype = _datatype === void 0 ? 1 : _datatype, reporttype = param.reporttype, statement = param.statement;
    var url = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/findata-view/company/financial");
    return requestExodus.get(url, {
        params: {
            symbol: symbol,
            data_type: datatype,
            report_type: reporttype,
            statement_type: statement
        }
    }).then(function(res) {
        var newRes = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, res.data);
        newRes.data.defaultCurrency = newRes.data.default_currency;
        newRes.data.htmlReport = newRes.data.html_report;
        newRes.data.rounding_value = {
            idr: newRes.data.rounding_value[0],
            usd: newRes.data.rounding_value[1]
        };
        delete newRes.data.default_currency;
        delete newRes.data.html_report;
        return newRes;
    });
};
/**
 * Get Analyst Rating
 * @param {string} symbol
 * @return {APIResponse}
 */ var getAnalystRating = function(symbol) {
    return requestExodus.get("analyst-ratings/".concat(symbol));
};
var getAnalystConsensus = function(symbol) {
    return requestExodus.get("analyst-ratings/".concat(symbol, "/consensus"));
};
var getCompanyHoldingCompositionToken = function() {
    return requestExodus.post("".concat(emittenMetadataURL, "/shareholders/token"));
};
var getCompanyHoldingComposition = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var symbol, type, timeframe, token, isFromWebview, _tries, tries, getToken, Authorization, res, ref, ref1, statusCode, newToken;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    symbol = param.symbol, type = param.type, timeframe = param.timeframe, token = param.token, isFromWebview = param.isFromWebview, _tries = param.tries, tries = _tries === void 0 ? 0 : _tries;
                    getToken = function() {
                        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                            var ref, tokenResponse, data;
                            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        ;
                                        _ctx.next = 3;
                                        return getCompanyHoldingCompositionToken();
                                    case 3:
                                        tokenResponse = _ctx.sent;
                                        data = tokenResponse.data;
                                        return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.value);
                                    case 6:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }));
                        return function getToken() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    _ctx.t1 = token;
                    if (_ctx.t1) {
                        _ctx.next = 10;
                        break;
                    }
                    _ctx.t2 = !isFromWebview;
                    if (!_ctx.t2) {
                        _ctx.next = 9;
                        break;
                    }
                    _ctx.next = 8;
                    return getToken();
                case 8:
                    _ctx.t2 = _ctx.sent;
                case 9:
                    _ctx.t1 = _ctx.t2;
                case 10:
                    _ctx.t0 = _ctx.t1;
                    if (_ctx.t0) {
                        _ctx.next = 13;
                        break;
                    }
                    _ctx.t0 = "";
                case 13:
                    Authorization = _ctx.t0;
                    _ctx.prev = 14;
                    if (Authorization) {
                        _ctx.next = 17;
                        break;
                    }
                    throw Error("No Access Token found");
                case 17:
                    _ctx.next = 19;
                    return axios__WEBPACK_IMPORTED_MODULE_5___default().get("".concat(emittenMetadataURL, "/shareholders/").concat(symbol, "/chart"), {
                        params: {
                            symbol: symbol,
                            value_year: timeframe,
                            shareholder_type: type
                        },
                        headers: {
                            Authorization: Authorization
                        }
                    });
                case 19:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 23:
                    _ctx.prev = 23;
                    _ctx.t3 = _ctx["catch"](14);
                    ;
                    ;
                    statusCode = (ref1 = _ctx.t3 === null || _ctx.t3 === void 0 ? void 0 : (ref = _ctx.t3.cause) === null || ref === void 0 ? void 0 : ref.status) !== null && ref1 !== void 0 ? ref1 : 401;
                    if (!(isFromWebview || statusCode !== 401 || tries >= 2)) {
                        _ctx.next = 30;
                        break;
                    }
                    throw _ctx.t3;
                case 30:
                    _ctx.next = 32;
                    return getToken();
                case 32:
                    newToken = _ctx.sent;
                    return _ctx.abrupt("return", getCompanyHoldingComposition({
                        symbol: symbol,
                        type: type,
                        timeframe: timeframe,
                        isFromWebview: isFromWebview,
                        token: newToken,
                        tries: tries + 1
                    }));
                case 34:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                14,
                23
            ]
        ]);
    }));
    return function getCompanyHoldingComposition(_) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Get company contact
 * @param {string} symbol
 * @return {APIResponse}
 */ var getCompanyContact = function(symbol) {
    return requestExodus.get("".concat(emittenURL, "/").concat(symbol, "/contact"));
};
var getTradeBook = function(params) {
    return requestExodus.get("".concat(orderTradeURL, "/trade-book"), {
        params: params
    });
};
var getInitRunningTrade = function(params) {
    return requestExodus.get("".concat(companyPriceFeedURL, "/running-trade"), {
        params: params
    });
};
var getInitRunningTradeV2 = function(params) {
    return requestExodus.get("".concat(companyPriceFeedURL, "/v2/running-trade"), {
        params: params
    });
};
var getCompanySubsidiary = function(symbol) {
    return requestExodus.get("".concat(emittenMetadataURL, "/subsidiary/").concat(symbol));
};
var getCompanyInfoV2 = function(symbol, exchange) {
    return requestExodus.get("".concat(emittenURL, "/v2/").concat(exchange, "/").concat(symbol, "/info"));
};
var getCompanyChartV2 = function(symbol, timeframe) {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/charts/").concat(symbol), {
        params: {
            timeframe: timeframe
        }
    });
};
var getCompanyFinItem = function(symbol, exchange) {
    return requestExodus.get("".concat(emittenURL, "/v2/").concat(exchange, "/").concat(symbol, "/fin-items"));
};
var getGuestCompanyV2 = function(symbol, exchange) {
    var reqDetail = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(false);
    return reqDetail.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/emitten/non-login/v2/").concat(exchange, "/").concat(symbol, "/info"));
};
var getGuestCompanyChartV2 = function(symbol, timeframe) {
    var reqDetail = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(false);
    return reqDetail.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/partnership/charts/").concat(symbol), {
        params: {
            timeframe: timeframe
        }
    });
};
var getGuestCompanyFinItem = function(symbol, exchange) {
    return axios__WEBPACK_IMPORTED_MODULE_5___default().get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/emitten/non-login/v2/").concat(exchange, "/").concat(symbol, "/fin-items"));
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getTrendingCompany: getTrendingCompany,
    getIHSG: getIHSG,
    getTendingCompanyPrices: getTendingCompanyPrices,
    getSearchCompany: getSearchCompany,
    getCompanyProfile: getCompanyProfile,
    getCompanyInfo: getCompanyInfo,
    getCompanyChart: getCompanyChart,
    getAnalystRating: getAnalystRating,
    getAnalystConsensus: getAnalystConsensus,
    getCompanyContact: getCompanyContact,
    getCompanyInfoV2: getCompanyInfoV2,
    getCompanyChartV2: getCompanyChartV2,
    getCompanyFinItem: getCompanyFinItem,
    // Hotlist
    getTopGainer: getTopGainer,
    getTopLoser: getTopLoser,
    getMostActive: getMostActive,
    // bandar detector
    getMarketDetector: getMarketDetector,
    getBrokerList: getBrokerList,
    getMarketDetectorActivity: getMarketDetectorActivity,
    getTopBroker: getTopBroker,
    // related to profile APIs
    getCompanyCorpAction: getCompanyCorpAction,
    getCompanyMajorholder: getCompanyMajorholder,
    getCompanySeasonality: getCompanySeasonality,
    getCompanyKeystat: getCompanyKeystat,
    getFinancialReport: getFinancialReport,
    getAllCorpAction: getAllCorpAction,
    // used for trading modal
    getCompanyHoldingCompositionToken: getCompanyHoldingCompositionToken,
    getCompanyHoldingComposition: getCompanyHoldingComposition,
    // Company Price Feed,
    getTradeBook: getTradeBook,
    getInitRunningTrade: getInitRunningTrade,
    getCompanySubsidiary: getCompanySubsidiary,
    getInitRunningTradeV2: getInitRunningTradeV2,
    getGuestCompanyV2: getGuestCompanyV2,
    getGuestCompanyChartV2: getGuestCompanyChartV2,
    getGuestCompanyFinItem: getGuestCompanyFinItem
});


/***/ }),

/***/ 69042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);


var SEARCH_GIF_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .GIPHY_URL */ .fN, "/search");
var TRENDING_GIF_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .GIPHY_URL */ .fN, "/trending");
var SEARCH_STICKER_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .GIPHY_STICKERS_URL */ .J3, "/search");
var TRENDING_STICKER_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .GIPHY_STICKERS_URL */ .J3, "/trending");
var getSearchGif = function(keyword) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return axios__WEBPACK_IMPORTED_MODULE_0___default().get(SEARCH_GIF_URL, {
        params: {
            api_key: constants_api__WEBPACK_IMPORTED_MODULE_1__/* .GIPHY_API_KEY */ .UY,
            q: keyword,
            limit: "30",
            offset: offset,
            rating: "G",
            lang: "en"
        }
    });
};
var getTrendingGif = function() {
    var offset = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return axios__WEBPACK_IMPORTED_MODULE_0___default().get(TRENDING_GIF_URL, {
        params: {
            api_key: constants_api__WEBPACK_IMPORTED_MODULE_1__/* .GIPHY_API_KEY */ .UY,
            limit: "30",
            offset: offset,
            rating: "G"
        }
    });
};
var getSearchSticker = function(keyword) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return axios__WEBPACK_IMPORTED_MODULE_0___default().get(SEARCH_STICKER_URL, {
        params: {
            api_key: constants_api__WEBPACK_IMPORTED_MODULE_1__/* .GIPHY_API_KEY */ .UY,
            q: keyword,
            limit: "30",
            offset: offset,
            rating: "G",
            lang: "en"
        }
    });
};
var getTrendingSticker = function() {
    var offset = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return axios__WEBPACK_IMPORTED_MODULE_0___default().get(TRENDING_STICKER_URL, {
        params: {
            api_key: constants_api__WEBPACK_IMPORTED_MODULE_1__/* .GIPHY_API_KEY */ .UY,
            limit: "30",
            offset: offset,
            rating: "G"
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getSearchGif: getSearchGif,
    getTrendingGif: getTrendingGif,
    getSearchSticker: getSearchSticker,
    getTrendingSticker: getTrendingSticker
});


/***/ }),

/***/ 47752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CP": function() { return /* binding */ getCategories; },
/* harmony export */   "Ht": function() { return /* binding */ getResearchIndicator; },
/* harmony export */   "RJ": function() { return /* binding */ getResearchData; }
/* harmony export */ });
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* eslint-disable import/named */ 

var researchUrl = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/research");
var request = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
var getCategories = function() {
    return request.get("".concat(researchUrl, "/categories"));
};
var getResearchData = function(params) {
    return request.get(researchUrl, {
        params: params
    });
};
var getResearchIndicator = function(symbol) {
    var params = symbol ? {
        symbol: symbol
    } : undefined;
    return request.get("".concat(researchUrl, "/indicator/new"), {
        params: params
    });
};


/***/ }),

/***/ 74645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_P": function() { return /* binding */ STATE_DETAIL; },
  "yM": function() { return /* binding */ STATE_SEARCH; },
  "IN": function() { return /* binding */ STATE_SUGGESTION; },
  "ZP": function() { return /* binding */ entities_company; },
  "Sz": function() { return /* binding */ effects; },
  "wl": function() { return /* binding */ selectors; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./src/lib/api/watchlist.ts
var watchlist = __webpack_require__(15056);
// EXTERNAL MODULE: ./src/lib/api/company.ts
var company = __webpack_require__(1349);
// EXTERNAL MODULE: ./src/lib/api/search.ts
var search = __webpack_require__(44590);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
;// CONCATENATED MODULE: ./src/lib/models/company/follow.js

var schema = {
    change: 0,
    companyid: "",
    followed: 0,
    followers: "",
    percent: 0,
    price: "",
    symbol: ""
};
var propTypes = {
    change: prop_types.number,
    companyid: prop_types.string,
    followed: prop_types.number,
    followers: prop_types.string,
    percent: prop_types.number,
    price: prop_types.string,
    symbol: prop_types.string
};
/* harmony default export */ var follow = ({
    schema: schema,
    propTypes: propTypes
});

;// CONCATENATED MODULE: ./src/lib/entities/company.ts









// States can be updated through follow/unfollow
var STATE_SUGGESTION = "suggestion";
var STATE_SEARCH = "search";
var STATE_DETAIL = "detail";
var defaultSummary = {
    brokers_buy: [],
    brokers_sell: [],
    symbol: ""
};
// Initial state
var initialState = {
    detail: {
        data: {},
        isLoading: false,
        error: null,
        message: ""
    },
    search: {
        data: [],
        isLoading: false,
        error: null,
        message: ""
    },
    chart: {
        data: {},
        popoverData: {},
        isLoading: false,
        error: null,
        message: ""
    },
    postFollowCompany: {
        data: [],
        isLoading: false,
        error: null,
        message: ""
    },
    postUnfollowCompany: {
        data: follow.schema,
        isLoading: false,
        error: null,
        message: ""
    },
    contact: {
        data: {},
        isLoading: false,
        error: null,
        message: ""
    },
    brokerSummary: {
        data: {
            detector: {},
            summary: defaultSummary,
            from: "",
            to: ""
        },
        isLoading: false,
        error: null,
        message: ""
    }
};
var companySelector = function(state) {
    return state.entities.company;
};
var selectors = (0,es/* createSelector */.P1)(companySelector, function(company) {
    return (0,_object_spread/* default */.Z)({}, company);
});
// Action types
var CONTEXT = "@redux/company";
var actionType = {
    FETCH_SEARCH: "".concat(CONTEXT, "/FETCH_SEARCH"),
    CLEAR_SEARCH: "".concat(CONTEXT, "/CLEAR_SEARCH"),
    POST_FOLLOW_COMPANY: "".concat(CONTEXT, "/POST_FOLLOW_COMPANY"),
    POST_UNFOLLOW_COMPANY: "".concat(CONTEXT, "/POST_UNFOLLOW_COMPANY"),
    GET_COMPANY_DETAIL: "".concat(CONTEXT, "/GET_COMPANY_DETAIL"),
    GET_COMPANY_CHART: "".concat(CONTEXT, "/GET_COMPANY_CHART"),
    GET_COMPANY_CONTACT: "".concat(CONTEXT, "/GET_COMPANY_CONTACT"),
    FOLLOW_USER: "".concat(CONTEXT, "/FOLLOW_USER"),
    GET_BANDAR_DETECTOR: "".concat(CONTEXT, "/GET_BANDAR_DETECTOR")
};
// symbol, timeframe
// Effects
// Side effect from external
var effects = {
    getSearchCompany: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.FETCH_SEARCH, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(keyword) {
            var response, _data, data, message, _$error, sanitizedData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return search/* default.getSearchCompany */.Z.getSearchCompany(keyword);
                    case 3:
                        response = _ctx.sent;
                        if (!response.data) {
                            _ctx.next = 10;
                            break;
                        }
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                        if (!_$error) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 8:
                        sanitizedData = (0,_to_consumable_array/* default */.Z)(data.company);
                        return _ctx.abrupt("return", {
                            data: sanitizedData,
                            message: message
                        });
                    case 10:
                        throw new Error("Attempt to fetch Search company Failed");
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }));
        return function(keyword) {
            return _ref.apply(this, arguments);
        };
    }()),
    getCompanyDetail: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_COMPANY_DETAIL, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(symbol) {
            var response, _data, _$error, message, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return company/* default.getCompanyInfo */.Z.getCompanyInfo(symbol);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to get company detail failed");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            symbol: symbol,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(symbol) {
            return _ref.apply(this, arguments);
        };
    }()),
    getCompanyChart: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_COMPANY_CHART, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var symbol, timeframe, _isPopover, isPopover, response, _data, _$error, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        symbol = param.symbol, timeframe = param.timeframe, _isPopover = param.isPopover, isPopover = _isPopover === void 0 ? false : _isPopover;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return company/* default.getCompanyChart */.Z.getCompanyChart(symbol, timeframe);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get company chart failed");
                    case 7:
                        _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            symbol: symbol,
                            isPopover: isPopover
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    // Update follow status company, given parameters
    // Watchlist ID, Company ID,
    // and state to be updated (search | suggestion | etc)
    postFollowCompany: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.POST_FOLLOW_COMPANY, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var watchlistId, companyId, _stateToUpdate, stateToUpdate, response, _data, data, message, _$error, sanitizedData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        watchlistId = param.watchlistId, companyId = param.companyId, _stateToUpdate = param.stateToUpdate, stateToUpdate = _stateToUpdate === void 0 ? STATE_SUGGESTION : _stateToUpdate;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return watchlist/* default.postFollowCompany */.Z.postFollowCompany(watchlistId, companyId);
                    case 4:
                        response = _ctx.sent;
                        if (!response.data) {
                            _ctx.next = 11;
                            break;
                        }
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error_type;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        sanitizedData = data[0];
                        return _ctx.abrupt("return", {
                            data: sanitizedData,
                            message: message,
                            stateToUpdate: stateToUpdate
                        });
                    case 11:
                        throw new Error("Attempt to post Follow company Failed");
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    14
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    // Update unfollow status company, given parameters
    // Watchlist ID, Company ID,
    // and state to be updated (search | suggestion | etc)
    postUnfollowCompany: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.POST_UNFOLLOW_COMPANY, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var watchlistId, companyId, _stateToUpdate, stateToUpdate, response, _data, data, message, _$error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        watchlistId = param.watchlistId, companyId = param.companyId, _stateToUpdate = param.stateToUpdate, stateToUpdate = _stateToUpdate === void 0 ? STATE_SUGGESTION : _stateToUpdate;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return watchlist/* default.postUnfollowCompany */.Z.postUnfollowCompany(watchlistId, companyId);
                    case 4:
                        response = _ctx.sent;
                        if (!response.data) {
                            _ctx.next = 10;
                            break;
                        }
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error_type;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            stateToUpdate: stateToUpdate
                        });
                    case 10:
                        throw new Error("Attempt to post Follow company Failed");
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getCompanyContact: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_COMPANY_CONTACT, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(symbol) {
            var response, _data, _$error, message, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return company/* default.getCompanyContact */.Z.getCompanyContact(symbol);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to get company detail failed");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            symbol: symbol,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(symbol) {
            return _ref.apply(this, arguments);
        };
    }()),
    // TODO integrate postFollowUser to watchlist followUser
    postFollowUser: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.FOLLOW_USER, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var username, userid, _type, type, targetAPI, response, _data, _$error, message, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        username = param.username, userid = param.userid, _type = param.type, type = _type === void 0 ? "FOLLOW" : _type;
                        _ctx.prev = 1;
                        if (userid) {
                            _ctx.next = 4;
                            break;
                        }
                        throw new Error("User id is empty");
                    case 4:
                        targetAPI = watchlist/* default.postFollowUser */.Z.postFollowUser;
                        if (type === "UNFOLLOW") {
                            targetAPI = watchlist/* default.postUnfollowUser */.Z.postUnfollowUser;
                        }
                        _ctx.next = 8;
                        return targetAPI(userid);
                    case 8:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 11;
                            break;
                        }
                        throw new Error("Attempt to follow user failed");
                    case 11:
                        _data = response.data, _$error = _data.error_type, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 14;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 14:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            type: type,
                            username: username,
                            userid: userid
                        });
                    case 17:
                        _ctx.prev = 17;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    17
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getBandarDetector: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_BANDAR_DETECTOR, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var symbol, params, response, _data, data, _$error, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        symbol = param.symbol, params = param.params;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return company/* default.getMarketDetector */.Z.getMarketDetector(symbol, params);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get market detector failed!");
                    case 7:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
var reducers = {
    clearSearch: function(state) {
        state.search.data = [];
    }
};
var extraReducers = function(builder) {
    builder.addCase(effects.getSearchCompany.pending, function(state) {
        state.detail.isLoading = true;
        state.detail.error = null;
    }).addCase(effects.getSearchCompany.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error;
        if (error) {
            state.search.error = error;
        } else {
            state.search.data = data;
        }
        state.search.message = message;
        state.search.isLoading = false;
    }).addCase(effects.getSearchCompany.rejected, function(state, action) {
        state.search.error = action.payload.error;
        state.search.isLoading = false;
    }).addCase(effects.getCompanyDetail.pending, function(state) {
        state.detail.isLoading = true;
        state.detail.error = null;
    }).addCase(effects.getCompanyDetail.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data, symbol = _payload.symbol;
        if (error) {
            state.detail.error = error;
        } else {
            state.detail.data[symbol] = data;
            state.detail.error = null;
        }
        state.detail.isLoading = false;
        state.detail.message = message;
    }).addCase(effects.getCompanyDetail.rejected, function(state, action) {
        state.detail.error = action.payload.error;
        state.detail.isLoading = false;
    }).addCase(effects.getCompanyChart.pending, function(state) {
        state.chart.isLoading = true;
        state.chart.error = null;
    }).addCase(effects.getCompanyChart.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data, symbol = _payload.symbol, isPopover = _payload.isPopover;
        if (error) {
            state.chart.error = error;
        } else {
            // data might be null, e.g. CPO timeframe 1d
            var newData = data ? (0,_object_spread/* default */.Z)({}, data) : null;
            // Inject Previous Price to 'today' prices
            // https://stockbit.atlassian.net/browse/IDT-501
            if (data && data.timeframe === "today" && data.prices.length && data.previous) {
                newData.prices = [
                    {
                        date: "0",
                        formatted_date: "",
                        xlabel: "0",
                        value: data.previous.toString(),
                        percentage: "0.00",
                        change: 0
                    }, 
                ].concat((0,_to_consumable_array/* default */.Z)(data.prices));
            }
            // Mini chart
            state.chart.data[symbol] = newData;
            // Popover chart
            if (isPopover) {
                state.chart.popoverData[symbol] = newData;
            }
            state.chart.error = null;
        }
        state.chart.isLoading = false;
        state.chart.message = message;
    }).addCase(effects.getCompanyChart.rejected, function(state, action) {
        state.chart.error = action.payload.error;
        state.chart.isLoading = false;
    }).addCase(effects.postFollowCompany.pending, function(state) {
        state.postFollowCompany.isLoading = true;
        state.postFollowCompany.error = null;
    }).addCase(effects.postFollowCompany.fulfilled, function(state, action) {
        var STATUS_FOLLOWING = 1;
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data, stateToUpdate = _payload.stateToUpdate;
        if (error) {
            state.postFollowCompany.error = error;
        } else {
            state.postFollowCompany.data = data;
            // TODO: Move to new function to wrap this, if allowed
            // update state search
            // find company with `id` == `data.companyId`
            // update followed value to `1`
            var companyid = data.companyid, symbol = data.symbol;
            var newDataState = state.search.data;
            var changedDataIndex = newDataState.findIndex(function(param) {
                var id = param.id;
                return Number(id) === Number(companyid);
            });
            // Do if else to only change specific data state based on
            // flag `stateToUpdate`
            if (stateToUpdate === STATE_SEARCH && changedDataIndex > -1) {
                state.search.data[changedDataIndex].is_following = !!STATUS_FOLLOWING;
            }
            if (stateToUpdate === STATE_DETAIL) {
                state.detail.data[symbol].followed = STATUS_FOLLOWING;
            }
        }
        state.postFollowCompany.message = message;
        state.postFollowCompany.isLoading = false;
    }).addCase(effects.postFollowCompany.rejected, function(state, action) {
        state.postFollowCompany.error = action.payload.error;
        state.postFollowCompany.isLoading = false;
    }).addCase(effects.postUnfollowCompany.pending, function(state) {
        state.postUnfollowCompany.isLoading = true;
        state.postUnfollowCompany.error = null;
    }).addCase(effects.postUnfollowCompany.fulfilled, function(state, action) {
        var STATUS_UNFOLLOWING = 0;
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data, stateToUpdate = _payload.stateToUpdate;
        if (error) {
            state.postUnfollowCompany.error = error;
        } else {
            state.postUnfollowCompany.data = data;
            // TODO: Move this to new function to wrap it, if allowed
            // update state
            // find company with `id` == `data.companyId`
            // update followed value to `1`
            var companyid = data.companyid, symbol = data.symbol;
            var newDataState = state.search.data;
            var changedDataIndex = newDataState.findIndex(function(param) {
                var id = param.id;
                return Number(id) === Number(companyid);
            });
            if (stateToUpdate === STATE_SEARCH && changedDataIndex > -1) {
                state.search.data[changedDataIndex].is_following = !!STATUS_UNFOLLOWING;
            }
            if (stateToUpdate === STATE_DETAIL) {
                state.detail.data[symbol].followed = STATUS_UNFOLLOWING;
            }
        }
        state.postUnfollowCompany.message = message;
        state.postUnfollowCompany.isLoading = false;
    }).addCase(effects.postUnfollowCompany.rejected, function(state, action) {
        state.postUnfollowCompany.error = action.payload.error;
        state.postUnfollowCompany.isLoading = false;
    }).addCase(effects.getCompanyContact.pending, function(state) {
        state.contact.isLoading = true;
        state.contact.error = null;
    }).addCase(effects.getCompanyContact.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data, symbol = _payload.symbol;
        if (error) {
            state.contact.error = error;
        } else {
            state.contact.data[symbol] = data;
            state.contact.error = null;
        }
        state.contact.isLoading = false;
        state.contact.message = message;
    }).addCase(effects.getCompanyContact.rejected, function(state, action) {
        state.contact.error = action.payload.error;
        state.contact.isLoading = false;
    }).addCase(effects.postFollowUser.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error, userid = _payload.userid, type = _payload.type, symbol = _payload.username;
        if (!error) {
            var activeSymbol = state.contact.data[symbol];
            if (activeSymbol) {
                var idx = activeSymbol.findIndex(function(item) {
                    return item.id === userid;
                });
                if (idx !== -1) {
                    var FOLLOWING = type === "FOLLOW" ? 1 : 0;
                    // If follow specific child, also add following to all watchlist
                    // Update the selected wathclist item
                    state.contact.data[symbol][idx].is_followed = FOLLOWING;
                }
            }
        }
    }).addCase(effects.getBandarDetector.pending, function(state) {
        state.brokerSummary.isLoading = true;
        state.brokerSummary.error = null;
    }).addCase(effects.getBandarDetector.fulfilled, function(state, action) {
        var _payload = action.payload, _data = _payload.data, data = _data === void 0 ? {} : _data, error = _payload.error, message = _payload.message;
        if (error) {
            state.brokerSummary.error = error;
        }
        if (!data.bandar_detector || !data.broker_summary) {
            state.brokerSummary.data.detector = {};
            state.brokerSummary.data.summary = defaultSummary;
            state.brokerSummary.data.from = "";
            state.brokerSummary.data.to = "";
            state.brokerSummary.error = null;
        }
        if (data.bandar_detector && data.broker_summary) {
            state.brokerSummary.data.detector = data.bandar_detector;
            state.brokerSummary.data.summary = data.broker_summary;
            state.brokerSummary.data.from = data.from;
            state.brokerSummary.data.to = data.to;
            state.brokerSummary.error = null;
        }
        state.brokerSummary.message = message;
        state.brokerSummary.isLoading = false;
    }).addCase(effects.getBandarDetector.rejected, function(state, action) {
        state.brokerSummary.error = action.payload.error;
        state.brokerSummary.isLoading = false;
    });
};
// Create redux slice
var companySlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "company",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ var entities_company = (companySlice);


/***/ }),

/***/ 25641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99534);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61876);
/* harmony import */ var utils_uploadStreamFiles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93589);
/* harmony import */ var lib_api_stream__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51679);
/* harmony import */ var constants_successMessage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41208);
/* harmony import */ var constants_errorMessage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61608);
/* harmony import */ var global_AlertMessage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6430);
/* harmony import */ var utils_stream__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14601);






// APIs






// Initial state
var initialState = {
    composeStream: {
        data: {},
        isLoading: false,
        success: false,
        error: null,
        message: ""
    },
    updatePostStream: {
        data: {},
        isLoading: false,
        error: null,
        message: ""
    },
    shareStream: {
        data: {},
        isLoading: false,
        error: null,
        message: ""
    },
    composeConversationStream: {
        data: {},
        isLoading: false,
        error: null,
        message: ""
    }
};
// Selectors
var streamSelector = function(state) {
    return state.entities.stream;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSelector */ .P1)(streamSelector, function(stream) {
    return {
        composeStream: stream.composeStream,
        shareStream: stream.shareStream,
        updatePostStream: stream.updatePostStream,
        composeConversation: stream.composeConversationStream
    };
});
// Action types
var CONTEXT = "@redux/stream";
var actionType = {
    POST_STREAM: "".concat(CONTEXT, "/post"),
    UPDATE_POST_STREAM: "".concat(CONTEXT, "/update_post"),
    SHARE_STREAM: "".concat(CONTEXT, "/share_post"),
    POST_CONVERSATION_STREAM: "".concat(CONTEXT, "/post_conversation")
};
// Effects
var effects = {
    postStream: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)(actionType.POST_STREAM, function() {
        var _ref = // @ts-ignore
        (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(streamData) {
            var file, image, isPinned, otherStreamDatas, dataUpload, dataStream, response, _data, data, message, _$error, postID, pinPostResponse;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        file = streamData.file, image = streamData.image, isPinned = streamData.isPinned, otherStreamDatas = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(streamData, [
                            "file",
                            "image",
                            "isPinned"
                        ]);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return (0,utils_uploadStreamFiles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(file, image);
                    case 4:
                        dataUpload = _ctx.sent;
                        if (!(dataUpload === null || dataUpload === void 0 ? void 0 : dataUpload.error)) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error(constants_errorMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"].STREAM_ERROR_UPLOAD_FILE */ .Z.STREAM_ERROR_UPLOAD_FILE);
                    case 7:
                        dataStream = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, otherStreamDatas), {
                            file: dataUpload.file,
                            images: dataUpload.image
                        });
                        _ctx.next = 10;
                        return lib_api_stream__WEBPACK_IMPORTED_MODULE_2__/* ["default"].postStream */ .Z.postStream(dataStream);
                    case 10:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 13;
                            break;
                        }
                        throw new Error("Attempt to post Compose stream Failed!");
                    case 13:
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                        if (!_$error) {
                            _ctx.next = 16;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 16:
                        // show alert success
                        (0,global_AlertMessage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                            content: constants_successMessage__WEBPACK_IMPORTED_MODULE_3__/* ["default"].POST_SUCCESSFUL */ .Z.POST_SUCCESSFUL,
                            alertType: "snackbar",
                            messageType: "success",
                            hasCloseIcon: true
                        });
                        postID = data.postid;
                        if (!(isPinned && postID)) {
                            _ctx.next = 24;
                            break;
                        }
                        _ctx.next = 21;
                        return lib_api_stream__WEBPACK_IMPORTED_MODULE_2__/* ["default"].pinPost */ .Z.pinPost(postID, null);
                    case 21:
                        pinPostResponse = _ctx.sent;
                        if (pinPostResponse.data) {
                            _ctx.next = 24;
                            break;
                        }
                        throw new Error("Attempt to pin post Failed!");
                    case 24:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 27:
                        _ctx.prev = 27;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 30:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    27
                ]
            ]);
        }));
        return function(streamData) {
            return _ref.apply(this, arguments);
        };
    }()),
    updatePostStream: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)(actionType.UPDATE_POST_STREAM, function() {
        var _ref = // @ts-ignore
        (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(streamData) {
            var file, image, otherStreamDatas, dataUpload, dataStream, update, response, _data, postData, message, _$error, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        file = streamData.file, image = streamData.image, otherStreamDatas = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(streamData, [
                            "file",
                            "image"
                        ]);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return (0,utils_uploadStreamFiles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(file, image);
                    case 4:
                        dataUpload = _ctx.sent;
                        if (!(dataUpload === null || dataUpload === void 0 ? void 0 : dataUpload.error)) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error(constants_errorMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"].STREAM_ERROR_UPLOAD_FILE */ .Z.STREAM_ERROR_UPLOAD_FILE);
                    case 7:
                        dataStream = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, otherStreamDatas), {
                            file: dataUpload.file,
                            images: dataUpload.image
                        });
                        _ctx.next = 10;
                        return lib_api_stream__WEBPACK_IMPORTED_MODULE_2__/* ["default"].updatePostStream */ .Z.updatePostStream(dataStream);
                    case 10:
                        update = _ctx.sent;
                        if (update.data) {
                            _ctx.next = 13;
                            break;
                        }
                        throw new Error("Attempt to post Compose stream Failed!");
                    case 13:
                        _ctx.next = 15;
                        return lib_api_stream__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getStreamDetail */ .Z.getStreamDetail(otherStreamDatas === null || otherStreamDatas === void 0 ? void 0 : otherStreamDatas.postid);
                    case 15:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 18;
                            break;
                        }
                        throw new Error("Attempt to get stream Failed!");
                    case 18:
                        _data = response.data, postData = _data.data, message = _data.message, _$error = _data.error;
                        if (!_$error) {
                            _ctx.next = 21;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 21:
                        // show alert success
                        (0,global_AlertMessage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                            content: constants_successMessage__WEBPACK_IMPORTED_MODULE_3__/* ["default"].POST_SUCCESSFUL_UPDATE */ .Z.POST_SUCCESSFUL_UPDATE,
                            alertType: "snackbar",
                            messageType: "success",
                            hasCloseIcon: true
                        });
                        data = (0,utils_stream__WEBPACK_IMPORTED_MODULE_6__/* .transformStreamV3 */ .hp)(postData);
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 26:
                        _ctx.prev = 26;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 29:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    26
                ]
            ]);
        }));
        return function(streamData) {
            return _ref.apply(this, arguments);
        };
    }()),
    shareStream: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)(actionType.SHARE_STREAM, function() {
        var _ref = // @ts-ignore
        (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(streamData) {
            var file, image, otherStreamDatas, dataUpload, dataStream, response, _data, _$error, data, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        file = streamData.file, image = streamData.image, otherStreamDatas = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(streamData, [
                            "file",
                            "image"
                        ]);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return (0,utils_uploadStreamFiles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(file, image);
                    case 4:
                        dataUpload = _ctx.sent;
                        if (!(dataUpload === null || dataUpload === void 0 ? void 0 : dataUpload.error)) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error(constants_errorMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"].STREAM_ERROR_UPLOAD_FILE */ .Z.STREAM_ERROR_UPLOAD_FILE);
                    case 7:
                        dataStream = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, otherStreamDatas), {
                            file: dataUpload.file,
                            images: dataUpload.image
                        });
                        _ctx.next = 10;
                        return lib_api_stream__WEBPACK_IMPORTED_MODULE_2__/* ["default"].sharePostStream */ .Z.sharePostStream(dataStream);
                    case 10:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 13;
                            break;
                        }
                        throw new Error("Attempt to share stream post failed");
                    case 13:
                        _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 16;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 16:
                        // show alert success
                        (0,global_AlertMessage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                            content: constants_successMessage__WEBPACK_IMPORTED_MODULE_3__/* ["default"].REPOST_SUCCESSFUL */ .Z.REPOST_SUCCESSFUL,
                            alertType: "snackbar",
                            messageType: "success",
                            hasCloseIcon: true
                        });
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 20:
                        _ctx.prev = 20;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 23:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    20
                ]
            ]);
        }));
        return function(streamData) {
            return _ref.apply(this, arguments);
        };
    }()),
    postConversationStream: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)(actionType.POST_CONVERSATION_STREAM, function() {
        var _ref = // @ts-ignore
        (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(streamData) {
            var file, image, otherStreamDatas, dataUpload, dataStream, response, _data, _$error, data, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        file = streamData.file, image = streamData.image, otherStreamDatas = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(streamData, [
                            "file",
                            "image"
                        ]);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return (0,utils_uploadStreamFiles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(file, image);
                    case 4:
                        dataUpload = _ctx.sent;
                        if (!(dataUpload === null || dataUpload === void 0 ? void 0 : dataUpload.error)) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error(constants_errorMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"].STREAM_ERROR_UPLOAD_FILE */ .Z.STREAM_ERROR_UPLOAD_FILE);
                    case 7:
                        dataStream = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, otherStreamDatas), {
                            file: dataUpload.file,
                            images: dataUpload.image
                        });
                        _ctx.next = 10;
                        return lib_api_stream__WEBPACK_IMPORTED_MODULE_2__/* ["default"].postReplyStream */ .Z.postReplyStream(dataStream);
                    case 10:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 13;
                            break;
                        }
                        throw new Error("Attempt to reply stream failed");
                    case 13:
                        _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 16;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 16:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 19:
                        _ctx.prev = 19;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 22:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    19
                ]
            ]);
        }));
        return function(streamData) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducers
var reducers = {};
// Extra reducers
var extraReducers = function(builder) {
    builder// Post stream -----------------------------------------------------
    .addCase(effects.postStream.pending, function(state) {
        state.composeStream.isLoading = true;
    }).addCase(effects.postStream.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, error = _payload.error, data = _payload.data;
        if (error) {
            state.composeStream.error = error;
        } else {
            state.composeStream.data = data;
            state.composeStream.success = true;
        }
        state.composeStream.message = message;
        state.composeStream.isLoading = false;
    }).addCase(effects.postStream.rejected, function(state, action) {
        state.composeStream.error = action.payload.error;
        state.composeStream.isLoading = false;
    })// Update stream -----------------------------------------------------
    .addCase(effects.updatePostStream.pending, function(state) {
        state.updatePostStream.isLoading = true;
        state.updatePostStream.error = null;
    }).addCase(effects.updatePostStream.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, error = _payload.error, data = _payload.data;
        if (error) {
            state.updatePostStream.error = error;
        } else {
            state.updatePostStream.data = data;
        }
        state.updatePostStream.message = message;
        state.updatePostStream.isLoading = false;
    }).addCase(effects.updatePostStream.rejected, function(state, action) {
        state.updatePostStream.error = action.payload.error;
        state.updatePostStream.isLoading = false;
    })// Share stream -----------------------------------------------------
    .addCase(effects.shareStream.pending, function(state) {
        state.shareStream.isLoading = true;
        state.shareStream.error = null;
    }).addCase(effects.shareStream.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, error = _payload.error, data = _payload.data;
        if (error) {
            state.shareStream.error = error;
        } else {
            state.shareStream.data = data;
            state.shareStream.error = null;
        }
        state.shareStream.message = message;
        state.shareStream.isLoading = false;
    }).addCase(effects.shareStream.rejected, function(state, action) {
        state.shareStream.error = action.payload.error;
        state.shareStream.isLoading = false;
    })// Post convo stream
    .addCase(effects.postConversationStream.pending, function(state) {
        state.composeConversationStream.isLoading = true;
        state.composeConversationStream.error = null;
    }).addCase(effects.postConversationStream.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, error = _payload.error, data = _payload.data;
        if (error) {
            state.composeConversationStream.error = error;
        } else {
            state.composeConversationStream.data = data;
            state.composeConversationStream.error = null;
        }
        state.composeConversationStream.message = message;
        state.composeConversationStream.isLoading = false;
    }).addCase(effects.postConversationStream.rejected, function(state, action) {
        state.composeConversationStream.error = action.payload.error;
        state.composeConversationStream.isLoading = false;
    });
};
// Slice
var stream = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSlice */ .oM)({
    name: "stream",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (stream);


/***/ }),

/***/ 4168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36305);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22147);
/* eslint-disable array-callback-return */ 




var MONTH_MAPPING = {
    1: "jan",
    2: "feb",
    3: "mar",
    4: "apr",
    5: "may",
    6: "jun",
    7: "jul",
    8: "aug",
    9: "sep",
    10: "oct",
    11: "nov",
    12: "dec"
};
var GENERAL_STATEMENT_TYPE = [
    {
        name: "Quarterly",
        value: 1
    },
    {
        name: "Annual",
        value: 2
    },
    {
        name: "TTM",
        value: 3
    },
    {
        name: "Interim YTD",
        value: 4
    },
    {
        name: "Q1",
        value: 5
    },
    {
        name: "Q2",
        value: 6
    },
    {
        name: "Q3",
        value: 7
    },
    {
        name: "Q4",
        value: 8
    }, 
];
var NON_ID_STATEMENT_TYPE = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(GENERAL_STATEMENT_TYPE);
var GROWTH_STATEMENT_TYPE = [
    {
        name: "QoQ Growth",
        value: 9
    },
    {
        name: "Quarter YoY Growth",
        value: 10
    },
    {
        name: "YTD YoY Growth",
        value: 11
    },
    {
        name: "Annual YoY Growth",
        value: 12
    },
    {
        name: "3 Year CAGR",
        value: 13
    }, 
];
var ID_STATEMENT_TYPE = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(GENERAL_STATEMENT_TYPE).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(GROWTH_STATEMENT_TYPE));
var EMITTEN_TYPE = {
    REKSA_DANA: "reksadana"
};
function colorHeatmap(val) {
    if (val > 0 && val <= 3) return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["seasonality-darkest-green"] */ .Z["seasonality-darkest-green"];
    if (val > 3 && val <= 8) return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["seasonality-medium-green"] */ .Z["seasonality-medium-green"];
    if (val > 8 && val <= 15) return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["seasonality-green"] */ .Z["seasonality-green"];
    if (val > 15) return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["seasonality-bright-green"] */ .Z["seasonality-bright-green"];
    if (val === 0) return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_0__/* ["default"].dimGray */ .Z.dimGray;
    if (val < 0 && val >= -3) return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["seasonality-darkest-red"] */ .Z["seasonality-darkest-red"];
    if (val < -3 && val >= -8) return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["seasonality-medium-red"] */ .Z["seasonality-medium-red"];
    if (val < -8 && val >= -15) return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["seasonality-red"] */ .Z["seasonality-red"];
    return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["seasonality-bright-red"] */ .Z["seasonality-bright-red"];
}
function percentageColorHeatmap2(val) {
    if (val === 0) return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_0__/* ["default"].dimGray */ .Z.dimGray;
    if (val < 50) return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["seasonality-medium-red"] */ .Z["seasonality-medium-red"];
    return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["seasonality-medium-green"] */ .Z["seasonality-medium-green"];
}
var formatingData = function(data) {
    var formatedData = {};
    Object.keys(data).forEach(function(keyParent) {
        formatedData[keyParent] = {};
        Object.keys(data[keyParent]).forEach(function(keyChild) {
            var numberAfterComma = data[keyParent][keyChild].toString().split(".");
            var mockupValue = data[keyParent][keyChild];
            formatedData[keyParent][keyChild] = numberAfterComma.length < 2 ? mockupValue : mockupValue.toFixed(2);
        });
    });
    return formatedData;
};
var formatDataYear = function(priceChangeData) {
    var formattedData = {};
    Object.keys(priceChangeData).map(function(index) {
        var priceData = priceChangeData[index];
        var monthData = {};
        priceData.months.map(function(data) {
            var numberAfterComma = data.price_change.toString().split(".");
            var mockupValue = data.price_change;
            var monthName = MONTH_MAPPING[data.month];
            monthData[monthName] = numberAfterComma.length < 2 ? mockupValue : mockupValue.toFixed(2);
        });
        formattedData[priceData.year] = monthData;
    });
    return formattedData;
};
/**
 * Get financial data statement type based on user country setting
 * @param country - User country
 * @returns {Array}
 */ var getStatementType = function() {
    var country = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "ID";
    if (country !== "ID") {
        return NON_ID_STATEMENT_TYPE;
    }
    return ID_STATEMENT_TYPE;
};
/**
 * Clean symbol prefix
 * @param {string} symbol
 * @returns {string}
 */ var cleanSymbol = function(symbol) {
    var regex = /klse-/gi;
    return symbol.replace(regex, "");
};
/**
 * Default API microservice response object
 */ var ENTITY = {
    seasonality: {
        price_change: [],
        avg: {},
        up: {},
        down: {},
        totalmonths: {},
        prob: {}
    }
};
/**
 * Translate new seasonality response API microservice into the old response format
 * @param {Object} SeasonalityResponse - The Response body.data from API seasonality microservice
 * @param {Array} SeasonalityResponse.price_change - The price change data
 * @param {Object} SeasonalityResponse.avg - The average seasonality data
 * @param {Object} SeasonalityResponse.up - The seasonality data up
 * @param {Object} SeasonalityResponse.down - The seasonality data down
 * @param {Object} SeasonalityResponse.totalmonths - The seasonality total months
 * @param {Object} SeasonalityResponse.prob - The seasonality probability
 */ var translateResponseSeasonality = function(param) {
    var _price_change = param.price_change, price_change = _price_change === void 0 ? ENTITY.seasonality.price_change : _price_change, _avg = param.avg, avg = _avg === void 0 ? ENTITY.seasonality.avg : _avg, _up = param.up, up = _up === void 0 ? ENTITY.seasonality.up : _up, _down = param.down, down = _down === void 0 ? ENTITY.seasonality.down : _down, _totalmonths = param.totalmonths, totalmonths = _totalmonths === void 0 ? ENTITY.seasonality.totalmonths : _totalmonths, _prob = param.prob, prob = _prob === void 0 ? ENTITY.seasonality.prob : _prob;
    var convertMonthToNumber = function() {
        var dataToConvert = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var monthToNumber = {
            jan: "1",
            feb: "2",
            mar: "3",
            apr: "4",
            may: "5",
            jun: "6",
            jul: "7",
            aug: "8",
            sep: "9",
            oct: "10",
            nov: "11",
            dec: "12",
            year: "13"
        };
        return Object.keys(dataToConvert).reduce(function(acc, curr) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, monthToNumber[curr], dataToConvert[curr]));
        }, {});
    };
    return price_change.reduce(function(acc, curr) {
        var dataYear = curr.months.reduce(function(_acc, _curr) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, _acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _curr.month, "".concat(_curr.price_change, "|").concat(_curr.color)));
        }, {});
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, curr.year, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, dataYear)));
    }, {
        avg: convertMonthToNumber(avg),
        up: convertMonthToNumber(up),
        down: convertMonthToNumber(down),
        totalmonths: convertMonthToNumber(totalmonths),
        prob: convertMonthToNumber(prob)
    });
};
var transformResponseSeasonalityFromServer = function(responseData) {
    var _loop = function(key) {
        var ref;
        newData[key] = {};
        if ((ref = data[key]) === null || ref === void 0 ? void 0 : ref.columns) {
            data[key].columns.forEach(function(col) {
                var value = "".concat(col.value, "|").concat(col.color);
                if ([
                    "up",
                    "down",
                    "totalmonths"
                ].includes(key)) {
                    value = col.value;
                }
                newData[key][col.name.toLowerCase()] = value;
            });
        } else {
            var monthNumber = {
                Jan: "1",
                Feb: "2",
                Mar: "3",
                Apr: "4",
                May: "5",
                Jun: "6",
                Jul: "7",
                Aug: "8",
                Sep: "9",
                Oct: "10",
                Nov: "11",
                Dec: "12",
                Year: "13"
            };
            newData[key] = data[key].map(function(dt) {
                return {
                    year: dt.row,
                    months: dt.columns.map(function(col) {
                        return {
                            month: monthNumber[col.name],
                            price_change: col.value,
                            color: col.color
                        };
                    })
                };
            });
        }
    };
    var data = {
        avg: responseData.avg,
        down: responseData.down,
        price_change: responseData.price_change,
        prob: responseData.prob,
        totalmonths: responseData.total_months,
        up: responseData.up
    };
    var newData = {};
    for(var key in data)_loop(key);
    return newData;
};
var isReksaDana = function(typeCompany) {
    if (!typeCompany) return false;
    return typeCompany.toLowerCase() === EMITTEN_TYPE.REKSA_DANA;
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    colorHeatmap: colorHeatmap,
    percentageColorHeatmap2: percentageColorHeatmap2,
    formatingData: formatingData,
    formatDataYear: formatDataYear,
    getStatementType: getStatementType,
    GROWTH_STATEMENT_TYPE: GROWTH_STATEMENT_TYPE,
    cleanSymbol: cleanSymbol,
    translateResponseSeasonality: translateResponseSeasonality,
    transformResponseSeasonalityFromServer: transformResponseSeasonalityFromServer,
    MONTH_MAPPING: MONTH_MAPPING,
    isReksaDana: isReksaDana
});


/***/ }),

/***/ 93589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ utils_uploadStreamFiles; },
  "Ii": function() { return /* binding */ uploadFileDocuments; },
  "eg": function() { return /* binding */ uploadImages; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/lib/api/stream.ts
var stream = __webpack_require__(51679);
;// CONCATENATED MODULE: ./src/features/stream/constants.js
var ALLOWED_IMAGE_MIMETYPE = [
    "jpg",
    "jpeg",
    "png",
    "gif"
];
var ALLOWED_DOC_MIMETYPE = [
    "pdf",
    "doc",
    "docx",
    "ppt",
    "pptx",
    "xls",
    "xlsx", 
];


// EXTERNAL MODULE: ./src/global/StreamCompose/constants.ts
var constants = __webpack_require__(79030);
// EXTERNAL MODULE: ./src/constants/errorMessage.js
var errorMessage = __webpack_require__(61608);
// EXTERNAL MODULE: ./src/global/AlertMessage/index.tsx
var AlertMessage = __webpack_require__(6430);
// EXTERNAL MODULE: ./src/utils/uploadHandler.ts
var uploadHandler = __webpack_require__(42826);
;// CONCATENATED MODULE: ./src/utils/uploadStreamFiles.ts
/* eslint-disable array-callback-return */ 








var uploadAllStreamFiles = function() {
    var files = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolve, reject) {
        // prepare filenames url param
        var filename = new URLSearchParams();
        files.map(function(item) {
            filename.append("filenames", item.file.name);
        });
        stream/* default.getUploadTokenV2 */.Z.getUploadTokenV2(filename).then(function(res) {
            var _data = res.data, _data1 = _data.data, tokens = _data1.tokens, url = _data1.url;
            var collection = [];
            var fileUrl = [];
            // Loop file to generate promise
            tokens.map(function(item, index) {
                var uploadPromise = (0,uploadHandler/* default */.Z)(files[index].file, url, item.fields, "stream");
                collection.push(uploadPromise);
                fileUrl.push({
                    url: item.view_url
                });
                return item;
            });
            // Upload all file in collection of fetch
            return Promise.all(collection).then(function() {
                resolve({
                    data: fileUrl
                });
            }).catch(function(err) {
                reject(new Error(err));
            });
        }).catch(function(err) {
            reject(err);
        });
    });
};
var uploadImages = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var images, imageList, uploadedImage, uploadFile, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    images = _args.length > 0 && _args[0] !== void 0 ? _args[0] : [];
                    imageList = [];
                    _ctx.prev = 2;
                    uploadedImage = images.filter(function(item) {
                        var fileExt = item.file.name.split(".").pop();
                        return ALLOWED_IMAGE_MIMETYPE.indexOf(fileExt.toLowerCase()) !== -1;
                    });
                    if (!(images.length > 0 && !uploadedImage[0])) {
                        _ctx.next = 7;
                        break;
                    }
                    (0,AlertMessage/* default */.Z)({
                        content: errorMessage/* default.UPLOAD_IMAGE_TYPE_NOT_SUPPORTED */.Z.UPLOAD_IMAGE_TYPE_NOT_SUPPORTED,
                        alertType: "snackbar",
                        messageType: "error",
                        hasCloseIcon: true
                    });
                    throw new Error(errorMessage/* default.UPLOAD_IMAGE_TYPE_NOT_SUPPORTED */.Z.UPLOAD_IMAGE_TYPE_NOT_SUPPORTED);
                case 7:
                    _ctx.next = 9;
                    return uploadAllStreamFiles(images);
                case 9:
                    uploadFile = _ctx.sent;
                    imageList = uploadFile.data.map(function(item) {
                        return item.url;
                    });
                    return _ctx.abrupt("return", {
                        data: imageList
                    });
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](2);
                    throw new Error(_ctx.t0);
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                14
            ]
        ]);
    }));
    return function uploadImages() {
        return _ref.apply(this, arguments);
    };
}();
var uploadFileDocuments = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var files, fileList, uploadedDocuments, uploadFile, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    files = _args.length > 0 && _args[0] !== void 0 ? _args[0] : [];
                    fileList = [];
                    _ctx.prev = 2;
                    uploadedDocuments = files.filter(function(item) {
                        var fileExt = item.file.name.split(".").pop();
                        return ALLOWED_DOC_MIMETYPE.indexOf(fileExt.toLowerCase()) !== -1;
                    });
                    if (!(files.length > 0 && !uploadedDocuments[0])) {
                        _ctx.next = 7;
                        break;
                    }
                    (0,AlertMessage/* default */.Z)({
                        content: errorMessage/* default.UPLOAD_DOCUMENT_TYPE_NOT_SUPPORTED */.Z.UPLOAD_DOCUMENT_TYPE_NOT_SUPPORTED,
                        alertType: "snackbar",
                        messageType: "error",
                        hasCloseIcon: true
                    });
                    throw new Error(errorMessage/* default.UPLOAD_DOCUMENT_TYPE_NOT_SUPPORTED */.Z.UPLOAD_DOCUMENT_TYPE_NOT_SUPPORTED);
                case 7:
                    _ctx.next = 9;
                    return uploadAllStreamFiles(files);
                case 9:
                    uploadFile = _ctx.sent;
                    fileList = uploadFile.data.map(function(item) {
                        return item.url;
                    });
                    return _ctx.abrupt("return", {
                        data: fileList
                    });
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](2);
                    throw new Error(_ctx.t0);
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                14
            ]
        ]);
    }));
    return function uploadFileDocuments() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Upload file from stream compose to Amazon S3
 * @param {Array} files
 * @returns {Object}
 */ var uploadStreamFiles = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(file, image) {
        var files, images, fileList, imageList, uploadedDocuments, uploadedImages, tmp, listOfImageUrl, tmp1, listOfDocumentUrl, _images, _files;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    files = [];
                    images = [];
                    if (!(file.length > 0 || image.length > 0)) {
                        _ctx.next = 29;
                        break;
                    }
                    _ctx.prev = 3;
                    fileList = [];
                    // sort out new document and existing document
                    file.map(function(data) {
                        if (typeof data === "string") {
                            files.push(data);
                        } else {
                            fileList.push({
                                file: data,
                                type: "file"
                            });
                        }
                    });
                    imageList = [];
                    // sort out new image and existing image
                    image.map(function(data) {
                        if ((data === null || data === void 0 ? void 0 : data.type) === constants/* IMAGE_TYPE_COMMON */.EZ && (data === null || data === void 0 ? void 0 : data.isNew)) {
                            imageList.push({
                                file: data === null || data === void 0 ? void 0 : data.file,
                                type: "image"
                            });
                        } else {
                            images.push(data.file);
                        }
                    });
                    _ctx.t0 = fileList.length > 0;
                    if (!_ctx.t0) {
                        _ctx.next = 13;
                        break;
                    }
                    _ctx.next = 12;
                    return uploadFileDocuments(fileList);
                case 12:
                    _ctx.t0 = _ctx.sent;
                case 13:
                    uploadedDocuments = _ctx.t0;
                    _ctx.t1 = imageList.length > 0;
                    if (!_ctx.t1) {
                        _ctx.next = 19;
                        break;
                    }
                    _ctx.next = 18;
                    return uploadImages(imageList);
                case 18:
                    _ctx.t1 = _ctx.sent;
                case 19:
                    uploadedImages = _ctx.t1;
                    tmp = uploadedImages.data, listOfImageUrl = tmp === void 0 ? [] : tmp;
                    tmp1 = uploadedDocuments.data, listOfDocumentUrl = tmp1 === void 0 ? [] : tmp1;
                    if (listOfImageUrl.length > 0) {
                        ;
                        (_images = images).push.apply(_images, (0,_to_consumable_array/* default */.Z)(listOfImageUrl));
                    }
                    if (listOfDocumentUrl.length > 0) {
                        ;
                        (_files = files).push.apply(_files, (0,_to_consumable_array/* default */.Z)(listOfDocumentUrl));
                    }
                    _ctx.next = 29;
                    break;
                case 26:
                    _ctx.prev = 26;
                    _ctx.t2 = _ctx["catch"](3);
                    return _ctx.abrupt("return", {
                        error: _ctx.t2
                    });
                case 29:
                    return _ctx.abrupt("return", {
                        file: files.join(),
                        image: images
                    });
                case 30:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                3,
                26
            ]
        ]);
    }));
    return function uploadStreamFiles(file, image) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var utils_uploadStreamFiles = (uploadStreamFiles);


/***/ })

}]);